import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Container, Row, Col, Button, Card, Modal, Carousel } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom'; 
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { toast } from 'react-toastify';
import { 
  FaClock,  
  FaPhone, 
  FaWhatsapp, 
  FaMapMarkerAlt, 
  FaCheckCircle,
  FaUser,
  FaCalendarAlt,
  FaCar,
  FaUsers,
  FaAward,
  FaHeart,
  FaRoad,
  FaMountain,
  FaWater,
  FaSun,
  FaEnvelope,
  FaChevronLeft,
  FaChevronRight
} from 'react-icons/fa';

// ============================================
// CONFIGURATION - UPDATE THIS WITH YOUR BACKEND URL
// ============================================
const API_URL = '';
const CLIENT_WHATSAPP_NUMBER = '918148111516';
const CLIENT_PHONE_NUMBER = '918148111516';
const ADMIN_EMAIL = 'lexusno1taxi@gmail.com';

// ============================================
// TAMIL NADU CITIES AND DISTANCES DATABASE
// ============================================
const tamilNaduCities = [
  { name: 'Chennai', lat: 13.0827, lng: 80.2707, district: 'Chennai' },
  { name: 'Coimbatore', lat: 11.0168, lng: 76.9558, district: 'Coimbatore' },
  { name: 'Madurai', lat: 9.9252, lng: 78.1198, district: 'Madurai' },
  { name: 'Tiruchirappalli', lat: 10.7905, lng: 78.7047, district: 'Tiruchirappalli' },
  { name: 'Tiruppur', lat: 11.1085, lng: 77.3411, district: 'Tiruppur' },
  { name: 'Salem', lat: 11.6643, lng: 78.1460, district: 'Salem' },
  { name: 'Erode', lat: 11.3410, lng: 77.7172, district: 'Erode' },
  { name: 'Tirunelveli', lat: 8.7139, lng: 77.7567, district: 'Tirunelveli' },
  { name: 'Vellore', lat: 12.9165, lng: 79.1325, district: 'Vellore' },
  { name: 'Thoothukkudi', lat: 8.7642, lng: 78.1348, district: 'Thoothukkudi' },
  { name: 'Dindigul', lat: 10.3624, lng: 77.9695, district: 'Dindigul' },
  { name: 'Thanjavur', lat: 10.7870, lng: 79.1378, district: 'Thanjavur' },
  { name: 'Ranipet', lat: 12.9235, lng: 79.3242, district: 'Ranipet' },
  { name: 'Krishnagiri', lat: 12.5187, lng: 78.2173, district: 'Krishnagiri' },
  { name: 'Karaikudi', lat: 10.0733, lng: 78.7798, district: 'Sivaganga' },
  { name: 'Kancheepuram', lat: 12.8222, lng: 79.7034, district: 'Kancheepuram' },
  { name: 'Cuddalore', lat: 11.7468, lng: 79.7643, district: 'Cuddalore' },
  { name: 'Nagapattinam', lat: 10.7650, lng: 79.8425, district: 'Nagapattinam' },
  { name: 'Kumbakonam', lat: 10.9562, lng: 79.3900, district: 'Thanjavur' },
  { name: 'Pudukkottai', lat: 10.3796, lng: 78.8211, district: 'Pudukkottai' },
  { name: 'Hosur', lat: 12.7409, lng: 77.8253, district: 'Krishnagiri' },
  { name: 'Nagercoil', lat: 8.1760, lng: 77.4295, district: 'Kanyakumari' },
  { name: 'Kanyakumari', lat: 8.0883, lng: 77.5385, district: 'Kanyakumari' },
  { name: 'Tiruvannamalai', lat: 12.2256, lng: 79.0745, district: 'Tiruvannamalai' },
  { name: 'Villupuram', lat: 11.9386, lng: 79.4898, district: 'Villupuram' },
  { name: 'Namakkal', lat: 11.2185, lng: 78.1748, district: 'Namakkal' },
  { name: 'Karur', lat: 10.9574, lng: 78.0767, district: 'Karur' },
  { name: 'Sivakasi', lat: 9.4500, lng: 77.8000, district: 'Virudhunagar' },
  { name: 'Rajapalayam', lat: 9.4500, lng: 77.5667, district: 'Virudhunagar' },
  { name: 'Pollachi', lat: 10.6583, lng: 77.0067, district: 'Coimbatore' },
  { name: 'Ooty', lat: 11.4069, lng: 76.6932, district: 'Nilgiris' },
  { name: 'Kodaikanal', lat: 10.2381, lng: 77.4892, district: 'Dindigul' },
  { name: 'Mettupalayam', lat: 11.3000, lng: 76.9333, district: 'Coimbatore' },
  { name: 'Avinashi', lat: 11.2000, lng: 77.2667, district: 'Tiruppur' },
  { name: 'Palladam', lat: 10.9833, lng: 77.3000, district: 'Tiruppur' },
  { name: 'Udumalpet', lat: 10.5833, lng: 77.2500, district: 'Tiruppur' },
  { name: 'Gobichettipalayam', lat: 11.4333, lng: 77.4500, district: 'Erode' },
  { name: 'Sathyamangalam', lat: 11.5000, lng: 77.2333, district: 'Erode' },
  { name: 'Bhavani', lat: 11.4500, lng: 77.6833, district: 'Erode' },
  { name: 'Rasipuram', lat: 11.4667, lng: 78.1667, district: 'Namakkal' },
  { name: 'Tiruchengode', lat: 11.3800, lng: 77.9000, district: 'Namakkal' },
  { name: 'Komarapalayam', lat: 11.4500, lng: 77.7000, district: 'Namakkal' },
  { name: 'Mettur', lat: 11.8000, lng: 77.8000, district: 'Salem' },
  { name: 'Edappadi', lat: 11.5667, lng: 77.6167, district: 'Salem' },
  { name: 'Attur', lat: 11.6000, lng: 78.6000, district: 'Salem' },
  { name: 'Vazhapadi', lat: 11.7333, lng: 78.4000, district: 'Salem' },
  { name: 'Palani', lat: 10.4500, lng: 77.5167, district: 'Dindigul' },
  { name: 'Oddanchatram', lat: 10.5000, lng: 77.7500, district: 'Dindigul' },
  { name: 'Vedasandur', lat: 10.5333, lng: 77.9500, district: 'Dindigul' },
  { name: 'Aruppukkottai', lat: 9.5167, lng: 78.1000, district: 'Virudhunagar' },
  { name: 'Virudhunagar', lat: 9.5833, lng: 77.9500, district: 'Virudhunagar' },
  { name: 'Srivilliputhur', lat: 9.5167, lng: 77.6333, district: 'Virudhunagar' },
  { name: 'Tenkasi', lat: 8.9667, lng: 77.3167, district: 'Tenkasi' },
  { name: 'Sankarankovil', lat: 9.2667, lng: 77.2000, district: 'Tenkasi' },
  { name: 'Ambasamudram', lat: 8.7000, lng: 77.4667, district: 'Tirunelveli' },
  { name: 'Valliyoor', lat: 8.4000, lng: 77.6167, district: 'Tirunelveli' },
  { name: 'Kallakurichi', lat: 11.7333, lng: 78.9500, district: 'Kallakurichi' },
  { name: 'Tindivanam', lat: 12.2333, lng: 79.6500, district: 'Villupuram' },
  { name: 'Gingee', lat: 12.2500, lng: 79.4167, district: 'Villupuram' },
  { name: 'Arakkonam', lat: 13.0833, lng: 79.6667, district: 'Ranipet' },
  { name: 'Walajapet', lat: 12.9333, lng: 79.3833, district: 'Ranipet' },
  { name: 'Melvisharam', lat: 13.0000, lng: 79.5833, district: 'Ranipet' },
  { name: 'Kovilpatti', lat: 9.1667, lng: 77.8667, district: 'Thoothukkudi' },
  { name: 'Ramanathapuram', lat: 9.3667, lng: 78.8333, district: 'Ramanathapuram' },
  { name: 'Paramakudi', lat: 9.5333, lng: 78.5833, district: 'Ramanathapuram' },
  { name: 'Mudukulathur', lat: 9.3333, lng: 78.5000, district: 'Ramanathapuram' },
  { name: 'Sivaganga', lat: 9.8667, lng: 78.4833, district: 'Sivaganga' },
  { name: 'Devakottai', lat: 9.9500, lng: 78.8333, district: 'Sivaganga' },
  { name: 'Manamadurai', lat: 9.7000, lng: 78.4833, district: 'Sivaganga' },
  { name: 'Courtallam', lat: 8.9333, lng: 77.2667, district: 'Tenkasi' },
  { name: 'Kutralam', lat: 8.9333, lng: 77.2667, district: 'Tenkasi' },
  { name: 'Courtalam', lat: 8.9333, lng: 77.2667, district: 'Tenkasi' }
];

// ============================================
// INDIA-ONLY PLACE SUGGESTIONS + REAL DISTANCE (Nominatim + OSRM)
// ============================================
const getCitySuggestions = async (input) => {
  if (!input || input.length < 2) return [];
  
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(input)}&format=json&addressdetails=1&limit=10&countrycodes=in`,
      {
        headers: {
          'User-Agent': 'LexusDropTaxi/1.0'
        }
      }
    );
    const data = await response.json();
    
    if (!data || data.length === 0) return [];
    
    const indiaOnly = data.filter(item => {
      const code = (item.address?.country_code || '').toLowerCase();
      const country = (item.address?.country || '').toLowerCase();
      return code === 'in' || country === 'india';
    });

    const suggestions = indiaOnly.map(item => {
      const city = item.address?.city || item.address?.town || item.address?.village || '';
      const state = item.address?.state || '';
      const country = item.address?.country || 'India';
      const label = city
        ? (state ? `${city}, ${state}, ${country}` : `${city}, ${country}`)
        : (item.display_name?.split(',').slice(0, 3).join(',').trim() || item.display_name);

      return {
        label,
        lat: parseFloat(item.lat),
        lon: parseFloat(item.lon)
      };
    }).filter(s => s.label && !Number.isNaN(s.lat) && !Number.isNaN(s.lon));

    // Deduplicate by label
    return suggestions.filter((v, i, a) => a.findIndex(x => x.label === v.label) === i);
    
  } catch (error) {
    console.error('Error fetching location suggestions:', error);
    const inputLower = input.toLowerCase();
    return tamilNaduCities
      .filter(city => city.name.toLowerCase().includes(inputLower))
      .slice(0, 5)
      .map(city => ({
        label: `${city.name}, Tamil Nadu, India`,
        lat: city.lat,
        lon: city.lng
      }));
  }
};

const geocodePlace = async (query) => {
  if (!query || query.trim().length < 2) return null;

  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&addressdetails=1&limit=1&countrycodes=in`,
      {
        headers: {
          'User-Agent': 'LexusDropTaxi/1.0'
        }
      }
    );
    const data = await response.json();
    if (!data || data.length === 0) return null;

    const item = data[0];
    return {
      lat: parseFloat(item.lat),
      lon: parseFloat(item.lon),
      label: item.display_name
    };
  } catch (error) {
    console.error('Geocode error:', error);
    return null;
  }
};

const getDrivingDistanceKm = async (fromCoords, toCoords) => {
  if (!fromCoords?.lat || !fromCoords?.lon || !toCoords?.lat || !toCoords?.lon) {
    return null;
  }

  try {
    const url =
      `https://router.project-osrm.org/route/v1/driving/` +
      `${fromCoords.lon},${fromCoords.lat};${toCoords.lon},${toCoords.lat}` +
      `?overview=false`;

    const response = await fetch(url);
    const data = await response.json();

    if (data?.code !== 'Ok' || !data?.routes?.[0]?.distance) {
      return null;
    }

    return Math.max(1, Math.round(data.routes[0].distance / 1000));
  } catch (error) {
    console.error('OSRM distance error:', error);
    return null;
  }
};

// ============================================
// LETTER STYLING
// ============================================
const letterStyle = {
  fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  fontWeight: '600',
  letterSpacing: '-0.02em',
  lineHeight: '1.4'
};

const headingStyle = {
  fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  fontWeight: '700',
  letterSpacing: '-0.03em',
  lineHeight: '1.3'
};

const boldStyle = {
  fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  fontWeight: '800',
  letterSpacing: '-0.02em'
};

const numberStyles = {
  fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  fontWeight: '700',
  fontSize: 'inherit',
  display: 'inline-block',
  letterSpacing: '-0.02em',
  color: 'inherit'
};

const OptimizedNumber = React.memo(({ num }) => {
  return <span style={numberStyles}>{num}</span>;
});

const Home = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [currentSlide, setCurrentSlide] = useState(0);
  const isAutoPlaying = true;
 
  const autoPlayRef = useRef(null);
  
  const [formData, setFormData] = useState({
    tripType: 'one-way',
    pickupLocation: '',
    dropLocation: '',
    name: user?.name || '',
    mobile: user?.phone || '',
    pickupDate: new Date().toISOString().split('T')[0],
    returnDate: '',
    pickupTime: '',
    carType: ''
  });

  const [pickupSuggestions, setPickupSuggestions] = useState([]);
  const [dropSuggestions, setDropSuggestions] = useState([]);
  const [showPickupSuggestions, setShowPickupSuggestions] = useState(false);
  const [showDropSuggestions, setShowDropSuggestions] = useState(false);
  const [calculatedDistance, setCalculatedDistance] = useState(0);
  const [distanceLoading, setDistanceLoading] = useState(false);
  const distanceRequestRef = useRef(0);
  const pickupCoordsRef = useRef(null);
  const dropCoordsRef = useRef(null);

  // Prefill From/To when arriving from Popular Routes "Book This Route"
  useEffect(() => {
    const pickup = location.state?.pickupLocation;
    const drop = location.state?.dropLocation;
    if (!pickup && !drop) return;

    pickupCoordsRef.current = null;
    dropCoordsRef.current = null;
    setFormData(prev => ({
      ...prev,
      ...(pickup ? { pickupLocation: pickup } : {}),
      ...(drop ? { dropLocation: drop } : {})
    }));
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/', { replace: true, state: null });
  }, [location.state, navigate]);

  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [fareEstimate, setFareEstimate] = useState(null);
  const [bookingInProgress, setBookingInProgress] = useState(false);

  const [counters, setCounters] = useState({
    trips: 0,
    rating: 0,
    awards: 0,
    customers: 0
  });

  const [statsVisible, setStatsVisible] = useState(false);
  const statsRef = useRef(null);
  const [tariffIndex, setTariffIndex] = useState(0);
  const [tariffTransition, setTariffTransition] = useState(true);
  const [tariffStepPx, setTariffStepPx] = useState(0);
  const [tariffCardWidthPx, setTariffCardWidthPx] = useState(0);
  const tariffLockRef = useRef(false);
  const tariffViewportRef = useRef(null);

  const carouselImages = useMemo(() => [
    {
      url: 'images/image1.jpg',
      title: 'Luxury Sedans',
      description: 'Comfortable and stylish sedans for your journey'
    },
    {
      url: 'images/image2.jpg',
      title: 'Spacious SUVs',
      description: 'Perfect for family trips and group travel'
    },
    {
      url: 'images/image3.jpg',
      title: 'Premium INNOVA',
      description: 'Experience luxury with our premium fleet'
    },
    {
      url: 'images/image4.jpg',
      title: 'Hill Station Trips',
      description: 'Special packages for mountain getaways'
    },
        {
      url: 'images/image5.jpg',
      title: 'Hill Station Trips',
      description: 'Special packages for mountain getaways'
    }
  ], []);

  const popularDestinations = useMemo(() => [
    {
      id: 1,
      name: 'TAMIL NADU',
      places: [
        'Chennai', 'Tiruvannamalai', 'Salem', 'Trichy Srirangam', 'Chidambaram',
        'Thanjavur', 'Kumbakonam', 'Nagapattinam', 'Pondicherry', 'Velankanni',
        'Madurai', 'Dindigul', 'Rameshwaram', 'Kanyakumari', 'Nagercoil',
        'Tirunelveli', 'Tiruchendur', 'Tenkasi Kutralam', 'Thoothukudi', 'Ooty',
        'Kodaikanal', 'Theni', 'Tirupur', 'Palani', 'Pollachi', 'Coimbatore'
      ]
    },
    {
      id: 2,
      name: 'KERALA',
      places: [
        'Thekkady', 'Munnar', 'Alappuzha', 'Thiruvananthapuram', 'Ernakulam Kochi',
        'Achankovil', 'Varkala Beach', 'Kovalam Beach', 'Guruvayur', 'Idukki',
        'Kozhikode', 'Thrissur', 'Kollam', 'Vagamon', 'Jatayu Rock',
        'Nanda Lake', 'Alleppey', 'Wayanad', 'Kovalam', 'Athirappilly',
        'Kumarakom', 'Pathiramanal', 'Palaruvi Falls', 'Kanthanpara Falls',
        'Rosemala View Point'
      ]
    },
    {
      id: 3,
      name: 'ANDHRA PRADESH',
      places: [
        'Araku Valley', 'Lambasingi', 'Horsley Hills', 'Tirupati', 'Lepakshi',
        'Gandikota', 'Visakhapatnam', 'Machilipatnam', 'Kakinada', 'Srisailam',
        'Mantralayam', 'Maredumilli', 'Rollapadu', 'Coringa'
      ]
    },
    {
      id: 4,
      name: 'KARNATAKA',
      places: [
        'Bangalore', 'Mysore', 'Murudeshwar', 'Coorg', 'Nandi Hills',
        'Gokarna', 'Belur', 'Halebid', 'Hampi', 'Kappatagudda',
        'Chikmagalur', 'Kabini', 'Nagarhole', 'Bandipur'
      ]
    }
  ], []);

  // Function to update fare based on distance
  const updateFareWithDistance = useCallback((distance, carNameOverride = null) => {
    const carName = carNameOverride || formData.carType;
    if (!carName) return;
    
    const selectedCar = cars.find(c => c.name === carName);
    if (!selectedCar) return;
    
    const actualDistance = Math.max(distance, 1);
    const rate = formData.tripType === 'round-trip' ? selectedCar.roundTripRate : selectedCar.oneWayRate;
    const bataPerDay = selectedCar.driverBata || 400;
    const hillCharges = selectedCar.hillCharges || 300;
    const extraPerKm = rate;
    let billableDistance = actualDistance;
    let tripDays = 1;
    let driverBata = bataPerDay;

    if (formData.tripType === 'one-way') {
      // Minimum 130 km for one-way trips
      billableDistance = Math.max(actualDistance, 130);
      tripDays = 1;
      driverBata = bataPerDay;
    } else {
      // Round trip: 250 km per day + driver bata per day
      tripDays = 1;
      billableDistance = 250;

      if (formData.pickupDate && formData.returnDate) {
        const pickupDate = new Date(formData.pickupDate);
        const returnDate = new Date(formData.returnDate);
        const diffMs = returnDate.setHours(0, 0, 0, 0) - pickupDate.setHours(0, 0, 0, 0);
        tripDays = Math.max(1, Math.floor(diffMs / (1000 * 60 * 60 * 24)) + 1);
        billableDistance = tripDays * 250;
      }

      driverBata = bataPerDay * tripDays;
    }

    const baseFare = rate * billableDistance;
    
    setCalculatedDistance(actualDistance);
    setFareEstimate({
      carName: selectedCar.name,
      rate: rate,
      actualDistance: actualDistance,
      billableDistance: billableDistance,
      tripDays: tripDays,
      baseFare: baseFare,
      driverBata: driverBata,
      bataPerDay: bataPerDay,
      hillCharges: hillCharges,
      extraPerKm: extraPerKm,
      total: baseFare + driverBata
    });
  }, [formData.carType, formData.tripType, formData.pickupDate, formData.returnDate, cars]);

  // Calculate real driving distance from selected pickup & drop
  useEffect(() => {
    let cancelled = false;
    const requestId = ++distanceRequestRef.current;

    const resolveDistance = async () => {
      if (!formData.pickupLocation || !formData.dropLocation) {
        setFareEstimate(null);
        setCalculatedDistance(0);
        setDistanceLoading(false);
        return;
      }

      setDistanceLoading(true);

      try {
        let from = pickupCoordsRef.current;
        let to = dropCoordsRef.current;

        if (!from) {
          from = await geocodePlace(formData.pickupLocation);
          if (!cancelled && from) {
            pickupCoordsRef.current = from;
          }
        }

        if (!to) {
          to = await geocodePlace(formData.dropLocation);
          if (!cancelled && to) {
            dropCoordsRef.current = to;
          }
        }

        if (cancelled || requestId !== distanceRequestRef.current) return;

        if (!from || !to) {
          setCalculatedDistance(0);
          setFareEstimate(null);
          setDistanceLoading(false);
          return;
        }

        const km = await getDrivingDistanceKm(from, to);

        if (cancelled || requestId !== distanceRequestRef.current) return;

        if (!km) {
          setCalculatedDistance(0);
          setFareEstimate(null);
          setDistanceLoading(false);
          return;
        }

        setCalculatedDistance(km);
        updateFareWithDistance(km);
      } catch (error) {
        console.error('Distance resolve error:', error);
        if (!cancelled) {
          setCalculatedDistance(0);
          setFareEstimate(null);
        }
      } finally {
        if (!cancelled && requestId === distanceRequestRef.current) {
          setDistanceLoading(false);
        }
      }
    };

    const timer = setTimeout(resolveDistance, 450);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [formData.pickupLocation, formData.dropLocation, formData.tripType, formData.carType, formData.pickupDate, formData.returnDate, updateFareWithDistance]);

  // ✅ CHANGE 2: Handle pickup location change with suggestions (ASYNC)
  const handlePickupChange = async (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, pickupLocation: value }));
    pickupCoordsRef.current = null;
    setCalculatedDistance(0);
    
    if (value.length >= 2) {
      const suggestions = await getCitySuggestions(value);
      setPickupSuggestions(suggestions);
      setShowPickupSuggestions(true);
    } else {
      setPickupSuggestions([]);
      setShowPickupSuggestions(false);
    }
  };

  // ✅ CHANGE 3: Handle drop location change with suggestions (ASYNC)
  const handleDropChange = async (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, dropLocation: value }));
    dropCoordsRef.current = null;
    setCalculatedDistance(0);
    
    if (value.length >= 2) {
      const suggestions = await getCitySuggestions(value);
      setDropSuggestions(suggestions);
      setShowDropSuggestions(true);
    } else {
      setDropSuggestions([]);
      setShowDropSuggestions(false);
    }
  };

  // Select suggestion for pickup
  const selectPickupSuggestion = (place) => {
    const coords = { lat: place.lat, lon: place.lon };
    pickupCoordsRef.current = coords;
    setFormData(prev => ({ ...prev, pickupLocation: place.label }));
    setPickupSuggestions([]);
    setShowPickupSuggestions(false);
  };

  // Select suggestion for drop
  const selectDropSuggestion = (place) => {
    const coords = { lat: place.lat, lon: place.lon };
    dropCoordsRef.current = coords;
    setFormData(prev => ({ ...prev, dropLocation: place.label }));
    setDropSuggestions([]);
    setShowDropSuggestions(false);
  };

  useEffect(() => {
    if (isAutoPlaying) {
      autoPlayRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
      }, 5000);
    }
    return () => {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
      }
    };
  }, [isAutoPlaying, carouselImages.length]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStatsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    const currentRef = statsRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  useEffect(() => {
    if (statsVisible) {
      const targets = {
        trips: 25000,
        rating: 48,
        awards: 10,
        customers: 20000
      };

      const duration = 1500;
      const steps = 30;
      const interval = duration / steps;

      let currentStep = 0;

      const timer = setInterval(() => {
        currentStep++;
        
        if (currentStep <= steps) {
          const progress = currentStep / steps;
          
          setCounters({
            trips: Math.min(Math.round(targets.trips * progress), targets.trips),
            rating: Math.min((targets.rating * progress) / 10, targets.rating / 10),
            awards: Math.min(Math.round(targets.awards * progress), targets.awards),
            customers: Math.min(Math.round(targets.customers * progress), targets.customers)
          });
        } else {
          setCounters({
            trips: targets.trips,
            rating: targets.rating / 10,
            awards: targets.awards,
            customers: targets.customers
          });
          clearInterval(timer);
        }
      }, interval);

      return () => clearInterval(timer);
    }
  }, [statsVisible]);

  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      pickupTime: getCurrentTime()
    }));

    const fetchCars = async () => {
      const defaultCars = [
        { name: 'SEDAN', displayName: 'SEDAN', oneWayRate: 15, roundTripRate: 14, driverBata: 400, hillCharges: 300 },
        { name: 'ETIOS', displayName: 'ETIOS', oneWayRate: 16, roundTripRate: 15, driverBata: 400, hillCharges: 300 },
        { name: 'MUV', displayName: 'MUV', oneWayRate: 20, roundTripRate: 19, driverBata: 400, hillCharges: 300 },
        { name: 'INNOVA', displayName: 'INNOVA', oneWayRate: 21, roundTripRate: 20, driverBata: 400, hillCharges: 300 },
        { name: 'CRYSTA', displayName: 'CRYSTA', oneWayRate: 24, roundTripRate: 23, driverBata: 500, hillCharges: 300 }
      ];

      try {
        const response = await axios.get(`${API_URL}/cars`);
        if (response.data.data && response.data.data.length > 0) {
          const byName = Object.fromEntries(response.data.data.map((c) => [c.name, c]));
          // Keep local rates + ensure all 5 car types (incl. CRYSTA) are available
          setCars(defaultCars.map((d) => ({ ...byName[d.name], ...d })));
        } else {
          setCars(defaultCars);
        }
      } catch (error) {
        console.error('Error fetching cars:', error);
        setCars(defaultCars);
      }
    };
    
    fetchCars();
  }, []);

  const fetchRecentBookings = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await axios.get(`${API_URL}/bookings/mybookings`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const recent = response.data.data.slice(0, 3);
      console.log('Recent bookings:', recent);
    } catch (error) {
      console.error('Error fetching recent bookings:', error);
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchRecentBookings();
      setFormData(prev => ({
        ...prev,
        name: user.name || '',
        mobile: user.phone || ''
      }));
    }
  }, [user, fetchRecentBookings]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const selectCar = (carName) => {
    setFormData(prev => ({
      ...prev,
      carType: carName
    }));

    const selectedCar = cars.find(c => c.name === carName);
    
    if (selectedCar && calculatedDistance > 0) {
      updateFareWithDistance(calculatedDistance, carName);
      toast.success(`${carName} selected - Fare calculated!`);
    } else {
      toast.info(`Please enter pickup and drop locations first for accurate fare`);
    }
  };

  // Convert 24-hour time to 12-hour format with AM/PM
  const formatTimeTo12Hour = (time24) => {
    if (!time24) return '';
    
    let [hours, minutes] = time24.split(':');
    hours = parseInt(hours);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minutesStr = minutes.padStart(2, '0');
    return `${hours}:${minutesStr} ${ampm}`;
  };

  const generateWhatsAppMessage = (booking) => {
    const tripTypeText = booking.tripType === 'one-way' ? 'ONE WAY' : 'ROUND TRIP';
    
    const formattedDate = new Date(booking.pickupDate).toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });

    const formattedReturnDate = booking.returnDate
      ? new Date(booking.returnDate).toLocaleDateString('en-IN', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        })
      : '';
    
    const formattedTime = formatTimeTo12Hour(booking.pickupTime);
    
    // Using simple text without problematic emojis for better WhatsApp compatibility
    return encodeURIComponent(
      `*NEW TAXI BOOKING - Lexus DROP TAXI*\n\n` +
      `----------------------------------------\n` +
      `Booking ID: ${booking.bookingId}\n` +
      `Customer Name: ${booking.name}\n` +
      `Customer Mobile: ${booking.mobile}\n` +
      `----------------------------------------\n` +
      `Car Type: ${booking.carType}\n` +
      `Trip Type: ${tripTypeText}\n` +
      `From: ${booking.pickupLocation}\n` +
      `To: ${booking.dropLocation}\n` +
      `Distance: ${booking.fareEstimate.actualDistance} km\n` +
      (booking.tripType === 'one-way'
        ? `Billable Distance: ${booking.fareEstimate.billableDistance} km${booking.fareEstimate.actualDistance < 130 ? ' (min 130 km)' : ''}\n`
        : '') +
      (booking.tripType === 'round-trip'
        ? `Trip Plan: ${booking.fareEstimate.tripDays} day(s) x 250 km = ${booking.fareEstimate.billableDistance} km\n`
        : '') +
      `Pickup Date: ${formattedDate}\n` +
      (formattedReturnDate ? `Return Date: ${formattedReturnDate}\n` : '') +
      `Time: ${formattedTime}\n` +
      `----------------------------------------\n` +
      `FARE DETAILS:\n` +
      `Rate: Rs.${booking.fareEstimate.rate}/km\n` +
      `Total Distance: ${booking.fareEstimate.billableDistance} km\n` +
      `Base Fare: Rs.${booking.fareEstimate.baseFare}\n` +
      `Driver Bata: Rs.${booking.fareEstimate.driverBata}${
        booking.tripType === 'round-trip' && booking.fareEstimate.tripDays > 1
          ? ` (${booking.fareEstimate.tripDays} x Rs.${booking.fareEstimate.bataPerDay || 400})`
          : ''
      }\n` +
      `TOTAL FARE: Rs.${booking.fareEstimate.total}\n` +
      `----------------------------------------\n` +
      (booking.tripType === 'one-way'
        ? `Note: One way minimum running is 130 km\n`
        : '') +
      (booking.tripType === 'round-trip'
        ? `Note: Package includes 250 km per day. Extra running above 250 km/day will be charged Rs.${booking.fareEstimate.extraPerKm}/km\n`
        : '') +
      `Note: Toll, state permit & hill charges extra if applicable\n` +
      `Hill Station Charges: Rs.${booking.fareEstimate.hillCharges || 300} (if applicable)\n\n` +
      `Contact Customer: ${booking.mobile}\n` +
      `Please confirm this booking with the customer.`
    );
  };

  const sendWhatsAppToClient = (message) => {
    const whatsappUrl = `https://wa.me/${CLIENT_WHATSAPP_NUMBER}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const generateEmailBody = (booking) => {
    const tripTypeText = booking.tripType === 'one-way' ? 'ONE WAY' : 'ROUND TRIP';
    const formattedDate = new Date(booking.pickupDate).toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    const formattedReturnDate = booking.returnDate
      ? new Date(booking.returnDate).toLocaleDateString('en-IN', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        })
      : '';
    const formattedTime = formatTimeTo12Hour(booking.pickupTime);

    return (
      `NEW TAXI BOOKING - Lexus DROP TAXI\n\n` +
      `----------------------------------------\n` +
      `Booking ID: ${booking.bookingId}\n` +
      `Customer Name: ${booking.name}\n` +
      `Customer Mobile: ${booking.mobile}\n` +
      `----------------------------------------\n` +
      `Car Type: ${booking.carType}\n` +
      `Trip Type: ${tripTypeText}\n` +
      `From: ${booking.pickupLocation}\n` +
      `To: ${booking.dropLocation}\n` +
      `Distance: ${booking.fareEstimate.actualDistance} km\n` +
      (booking.tripType === 'one-way'
        ? `Billable Distance: ${booking.fareEstimate.billableDistance} km${booking.fareEstimate.actualDistance < 130 ? ' (min 130 km)' : ''}\n`
        : '') +
      (booking.tripType === 'round-trip'
        ? `Trip Plan: ${booking.fareEstimate.tripDays} day(s) x 250 km = ${booking.fareEstimate.billableDistance} km\n`
        : '') +
      `Pickup Date: ${formattedDate}\n` +
      (formattedReturnDate ? `Return Date: ${formattedReturnDate}\n` : '') +
      `Time: ${formattedTime}\n` +
      `----------------------------------------\n` +
      `FARE DETAILS:\n` +
      `Rate: Rs.${booking.fareEstimate.rate}/km\n` +
      `Total Distance: ${booking.fareEstimate.billableDistance} km\n` +
      `Base Fare: Rs.${booking.fareEstimate.baseFare}\n` +
      `Driver Bata: Rs.${booking.fareEstimate.driverBata}${
        booking.tripType === 'round-trip' && booking.fareEstimate.tripDays > 1
          ? ` (${booking.fareEstimate.tripDays} x Rs.${booking.fareEstimate.bataPerDay || 400})`
          : ''
      }\n` +
      `TOTAL FARE: Rs.${booking.fareEstimate.total}\n` +
      `----------------------------------------\n` +
      (booking.tripType === 'one-way'
        ? `Note: One way minimum running is 130 km\n`
        : '') +
      (booking.tripType === 'round-trip'
        ? `Note: Package includes 250 km per day. Extra running above 250 km/day will be charged Rs.${booking.fareEstimate.extraPerKm}/km\n`
        : '') +
      `Note: Toll, state permit & hill charges extra if applicable\n` +
      `Hill Station Charges: Rs.${booking.fareEstimate.hillCharges || 300} (if applicable)\n\n` +
      `Contact Customer: ${booking.mobile}\n` +
      `Please confirm this booking with the customer.`
    );
  };

  const sendEmailToAdmin = async (booking) => {
    const emailBody = generateEmailBody(booking);

    try {
      const response = await fetch(`https://formsubmit.co/ajax/${ADMIN_EMAIL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          name: booking.name,
          phone: booking.mobile,
          bookingId: booking.bookingId,
          carType: booking.carType,
          tripType: booking.tripType,
          pickupLocation: booking.pickupLocation,
          dropLocation: booking.dropLocation,
          pickupDate: booking.pickupDate,
          pickupTime: booking.pickupTime,
          totalFare: booking.fareEstimate?.total,
          message: emailBody,
          _subject: `New Taxi Booking - ${booking.bookingId}`,
          _template: 'table',
          _captcha: 'false'
        })
      });

      if (!response.ok) {
        throw new Error('Email service responded with an error');
      }

      return true;
    } catch (error) {
      console.error('Email send failed, opening mail client fallback:', error);
      const subject = encodeURIComponent(`New Taxi Booking - ${booking.bookingId}`);
      const body = encodeURIComponent(emailBody);
      window.open(`mailto:${ADMIN_EMAIL}?subject=${subject}&body=${body}`, '_blank');
      return false;
    }
  };

  const saveBookingToBackend = async (bookingData) => {
    try {
      const token = localStorage.getItem('token');
      
      const backendBookingData = {
        tripType: bookingData.tripType,
        carType: bookingData.carType,
        pickupLocation: bookingData.pickupLocation,
        dropLocation: bookingData.dropLocation,
        pickupDate: bookingData.pickupDate,
        pickupTime: bookingData.pickupTime,
        distance: bookingData.fareEstimate.actualDistance,
        estimatedFare: bookingData.fareEstimate.baseFare,
        driverBata: bookingData.fareEstimate.driverBata,
        totalFare: bookingData.fareEstimate.total,
        customerName: bookingData.name,
        customerMobile: bookingData.mobile,
        bookingId: bookingData.bookingId,
        status: 'confirmed'
      };

      if (token) {
        const response = await axios.post(`${API_URL}/bookings`, backendBookingData, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        return response.data.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error saving booking to backend:', error);
      return null;
    }
  };

  const saveToLocalStorage = (bookingData) => {
    try {
      const localBookings = JSON.parse(localStorage.getItem('localBookings') || '[]');
      localBookings.unshift({
        ...bookingData,
        savedAt: new Date().toISOString()
      });
      localStorage.setItem('localBookings', JSON.stringify(localBookings.slice(0, 20)));
      return true;
    } catch (error) {
      console.error('Error saving to localStorage:', error);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.pickupLocation || !formData.dropLocation) {
      toast.error('Please enter pickup and drop locations');
      return;
    }

    if (!formData.name || formData.name.trim().length < 2) {
      toast.error('Please enter a valid name');
      return;
    }

    if (!formData.mobile || !/^[6-9]\d{9}$/.test(formData.mobile)) {
      toast.error('Please enter a valid 10-digit mobile number');
      return;
    }

    if (!formData.carType) {
      toast.error('Please select a car type');
      return;
    }

    if (formData.tripType === 'round-trip') {
      if (!formData.returnDate) {
        toast.error('Please select a return date');
        return;
      }
      if (formData.returnDate < formData.pickupDate) {
        toast.error('Return date must be on or after pickup date');
        return;
      }
    }

    if (!fareEstimate) {
      toast.error('Please wait for fare calculation');
      return;
    }

    if (bookingInProgress) {
      toast.info('Booking in progress...');
      return;
    }

    setBookingInProgress(true);
    setLoading(true);

    try {
      const bookingData = {
        ...formData,
        fareEstimate,
        bookingId: `LEX${Date.now()}${Math.random().toString(36).substr(2, 4).toUpperCase()}`,
        bookingDate: new Date().toISOString(),
        status: 'confirmed'
      };
      
      let savedBooking = null;
      
      if (user) {
        toast.info('Saving your booking...');
        savedBooking = await saveBookingToBackend(bookingData);
        if (savedBooking) {
          toast.success('Booking saved successfully!');
          bookingData._id = savedBooking._id;
        } else {
          toast.warning('Saved locally - backend not available');
        }
      }
      
      saveToLocalStorage(bookingData);
      
      const clientMessage = generateWhatsAppMessage(bookingData);
      sendWhatsAppToClient(clientMessage);

      const emailSent = await sendEmailToAdmin(bookingData);
      if (emailSent) {
        toast.success('Booking email sent to admin!');
      } else {
        toast.info('Email draft opened — please click Send if needed.');
      }
      
      setShowSuccessPopup(true);
      
      setFormData({
        tripType: 'one-way',
        pickupLocation: '',
        dropLocation: '',
        name: user?.name || '',
        mobile: user?.phone || '',
        pickupDate: new Date().toISOString().split('T')[0],
        returnDate: '',
        pickupTime: getCurrentTime(),
        carType: ''
      });
      setFareEstimate(null);
      setCalculatedDistance(0);
      pickupCoordsRef.current = null;
      dropCoordsRef.current = null;
      
      toast.success('Booking confirmed! Admin will contact you shortly.');
      
    } catch (error) {
      console.error('Booking error:', error);
      toast.error('Booking failed. Please try again or contact support.');
    } finally {
      setLoading(false);
      setBookingInProgress(false);
    }
  };

  const handlePopupClose = () => {
    setShowSuccessPopup(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const stats = [
    { icon: '🚗', value: counters.trips, label: 'Trips Completed', suffix: '+' },
    { icon: '⭐', value: counters.rating, label: 'Customer Rating', suffix: '', isDecimal: true },
    { icon: '🏆', value: counters.awards, label: 'Awards', suffix: '+' },
    { icon: '👥', value: counters.customers, label: 'Happy Customers', suffix: '+' }
  ];

  const tariffCars = useMemo(
    () => [
      {
        name: "SEDAN",
        displayName: "Sedan",
        oneWayRate: 15,
        roundTripRate: 14,
        capacity: "4+1",
        ac: "Yes",
        driverBata: 400,
        hillCharges: 300,
        permitCharge: 14,
        images: [
          {
            url: "/images/sedan/1.jpg",
            model: "TATA ZEST",
            bgColor: "#FFD700",
          },
          {
            url: "/images/sedan/2.jpg",
            model: "SWIFT DZIRE",
            bgColor: "#FFD700",
          },
          {
            url: "/images/sedan/3.jpg",
            model: "HYNDAI AURA",
            bgColor: "#FFD700",
          },
        ],
      },
      {
        name: "ETIOS",
        displayName: "Etios",
        oneWayRate: 16,
        roundTripRate: 15,
        capacity: "4+1",
        ac: "Yes",
        driverBata: 400,
        hillCharges: 300,
        permitCharge: 14,
        images: [
          {
            url: "/images/sedan2/1.jpg",
            model: "NISSIAN SUNNY",
            bgColor: "#FFD700",
          },
          {
            url: "/images/sedan2/2.jpg",
            model: "TOYOTA ",
            bgColor: "#FFD700",
          },
          {
            url: "/images/sedan2/3.jpg",
            model: "MARUTI CIAZ",
            bgColor: "#FFD700",
          },
        ],
      },
      {
        name: "MUV",
        displayName: "MUV",
        oneWayRate: 20,
        roundTripRate: 19,
        capacity: "6+1 / 7+1",
        ac: "Yes",
        driverBata: 400,
        hillCharges: 300,
        permitCharge: 14,
        images: [
          { url: "/images/suv/xylo-1.jpg", model: "XYLO", bgColor: "#FFD700" },
          {
            url: "/images/suv/SUV.jpg",
            model: "MARUTI ERTIGA",
            bgColor: "#FFD700",
          },
          {
            url: "/images/suv/SUV-1.jpg",
            model: "MARUTI ERTIGA",
            bgColor: "#FFD700",
          },
          {
            url: "/images/suv/marazzo-1.jpg",
            model: "MARAZZO",
            bgColor: "#FFD700",
          },
        ],
      },
      {
        name: "INNOVA",
        displayName: "Innova",
        oneWayRate: 21,
        roundTripRate: 20,
        capacity: "6+1 / 7+1",
        ac: "Yes",
        driverBata: 400,
        hillCharges: 300,
        permitCharge: 14,
        images: [
          {
            url: "/images/innova/INNOVA.jpg",
            model: "VEHICLE",
            bgColor: "#FFD700",
          },
        ],
      },
      {
        name: "CRYSTA",
        displayName: "Crysta",
        oneWayRate: 24,
        roundTripRate: 23,
        capacity: "6+1 / 7+1",
        ac: "Yes",
        driverBata: 500,
        hillCharges: 300,
        permitCharge: 14,
        images: [
          {
            url: "/images/crysta/CRYSTA.jpg",
            model: "INNOVA CRYSTA",
            bgColor: "#FFD700",
          },
        ],
      },
    ],
    [],
  );

  const TARIFF_VISIBLE = 3;
  const extendedTariffCars = useMemo(
    () => [...tariffCars, ...tariffCars.slice(0, TARIFF_VISIBLE)],
    [tariffCars]
  );

  const scrollTariffCards = (direction) => {
    if (tariffLockRef.current || tariffCars.length === 0) return;
    tariffLockRef.current = true;
    const total = tariffCars.length;

    if (direction < 0 && tariffIndex === 0) {
      setTariffTransition(false);
      setTariffIndex(total);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTariffTransition(true);
          setTariffIndex(total - 1);
        });
      });
      return;
    }

    setTariffTransition(true);
    setTariffIndex((prev) => prev + direction);
  };

  useEffect(() => {
    if (!tariffCars.length) return undefined;
    const total = tariffCars.length;

    if (tariffIndex < total) {
      const unlockTimer = setTimeout(() => {
        tariffLockRef.current = false;
      }, 480);
      return () => clearTimeout(unlockTimer);
    }

    const resetTimer = setTimeout(() => {
      setTariffTransition(false);
      setTariffIndex(0);
      requestAnimationFrame(() => {
        tariffLockRef.current = false;
      });
    }, 480);

    return () => clearTimeout(resetTimer);
  }, [tariffIndex, tariffCars.length]);

  useEffect(() => {
    const measureTariffStep = () => {
      const viewport = tariffViewportRef.current;
      if (!viewport) return;
      const gap = 16;
      const cardWidth = (viewport.clientWidth - gap * 2) / 3;
      setTariffCardWidthPx(cardWidth);
      setTariffStepPx(cardWidth + gap);
    };

    measureTariffStep();
    window.addEventListener('resize', measureTariffStep);
    return () => window.removeEventListener('resize', measureTariffStep);
  }, [extendedTariffCars.length]);

  const popularRoutes = useMemo(() => [
    {
      from: 'Kanyakumari',
      to: 'Chennai',
      icon: <FaWater />,
      images: ['/images/routess/kanniyakumari-to-chennai.jpg'],
      description: 'Southern tip to the capital - Comfortable coastal journey',
      distance: '250 km',
      cars: [
        { type: 'SEDAN', oneWay: 15, roundTrip: 14 },
        { type: 'ETIOS', oneWay: 16, roundTrip: 15 },
        { type: 'MUV', oneWay: 20, roundTrip: 19 },
        { type: 'INNOVA', oneWay: 21, roundTrip: 20 },
        { type: 'CRYSTA', oneWay: 24, roundTrip: 23 }
      ]
    },
    {
      from: 'Chennai',
      to: 'Kodaikanal',
      icon: <FaMountain />,
      images: [
        '/images/routess/Chennai-to-Kodaikanal.jpg'
      ],
      description: 'Princess of Hill Stations - Scenic beauty & pleasant climate',
      distance: '525 km',
      cars: [
        { type: 'SEDAN', oneWay: 15, roundTrip: 14 },
        { type: 'ETIOS', oneWay: 16, roundTrip: 15 },
        { type: 'MUV', oneWay: 20, roundTrip: 19 },
        { type: 'INNOVA', oneWay: 21, roundTrip: 20 },
        { type: 'CRYSTA', oneWay: 24, roundTrip: 23 }
      ]
    },
    {
      from: 'Chennai',
      to: 'Tenkasi',
      icon: <FaRoad />,
      images: [
        '/images/routess/Chennai-to-Tenkasi.jpg'
      ],
      description: 'Temple town journey - Comfortable outstation travel',
      distance: '650 km',
      cars: [
        { type: 'SEDAN', oneWay: 15, roundTrip: 14 },
        { type: 'ETIOS', oneWay: 16, roundTrip: 15 },
        { type: 'MUV', oneWay: 20, roundTrip: 19 },
        { type: 'INNOVA', oneWay: 21, roundTrip: 20 },
        { type: 'CRYSTA', oneWay: 24, roundTrip: 23 }
      ]
    },
    {
      from: 'Chennai',
      to: 'Coimbatore',
      icon: <FaSun />,
      images: [
        '/images/routess/Chennai-to-Coimbatore.jpg'
      ],
      description: 'Capital to textile city - Smooth highway ride',
      distance: '521 km',
      cars: [
        { type: 'SEDAN', oneWay: 15, roundTrip: 14 },
        { type: 'ETIOS', oneWay: 16, roundTrip: 15 },
        { type: 'MUV', oneWay: 20, roundTrip: 19 },
        { type: 'INNOVA', oneWay: 21, roundTrip: 20 },
        { type: 'CRYSTA', oneWay: 24, roundTrip: 23 }
      ]
    }
  ], []);

  const aboutStats = useMemo(() => [
    { icon: <FaCar />, value: '25000+', label: 'Trips Completed' },
    { icon: <FaUsers />, value: '20000+', label: 'Happy Customers' },
    { icon: <FaAward />, value: '10+', label: 'Awards' },
    { icon: <FaHeart />, value: '100+', label: 'Fleet Size' }
  ], []);

  const generateSparkles = useCallback(() => {
    const sparkles = [];
    for (let i = 0; i < 15; i++) {
      const size = Math.random() * 3 + 1;
      const style = {
        position: 'absolute',
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor: `rgba(255, 255, 255, ${Math.random() * 0.7 + 0.3})`,
        borderRadius: '50%',
        boxShadow: `0 0 ${Math.random() * 8 + 2}px rgba(255, 215, 0, 0.6)`,
        animation: `sparkle ${Math.random() * 4 + 3}s infinite ease-in-out`,
        animationDelay: `${Math.random() * 3}s`,
        zIndex: 10,
        pointerEvents: 'none',
        willChange: 'transform, opacity'
      };
      sparkles.push(<div key={`sparkle-${i}`} className="sparkle" style={style}></div>);
    }
    return sparkles;
  }, []);

  const formStyles = {
    card: {
      borderRadius: '20px',
      maxWidth: '500px',
      margin: '0 auto',
      width: '100%',
      backgroundColor: '#0c7a24e6',
      backgroundImage: `
        radial-gradient(circle at 20% 30%, rgba(207, 236, 42, 0.93) 0%, transparent 40%),
        radial-gradient(circle at 80% 70%, rgba(176, 212, 29, 0.86) 0%, transparent 40%),
        linear-gradient(145deg, #cad527ff 0%, #cad527ff 30%, #cad527ff 50%, #cad527ff 70%, #d6dee6e6 100%)
      `,
      boxShadow: `
        0 30px 60px rgba(139, 0, 0, 0.6),
        0 0 0 2px rgba(255, 215, 0, 0.3) inset,
        0 0 30px rgba(255, 215, 0, 0.2) inset
      `,
      border: '1px solid rgba(255, 215, 0, 0.4)',
      position: 'relative',
      overflow: 'hidden',
      transition: 'all 0.5s ease',
      willChange: 'transform, box-shadow'
    },
    cardBody: {
      padding: '1.8rem',
      position: 'relative',
      zIndex: 20
    },
    title: {
      fontSize: '1.6rem',
      marginBottom: '1.2rem',
      color: '#FFFFFF',
      textShadow: '2px 2px 4px rgba(0,0,0,0.6)',
      ...headingStyle
    },
    label: {
      fontSize: '0.95rem',
      marginBottom: '0.3rem',
      color: '#FFFFFF',
      fontWeight: '600',
      textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
      ...letterStyle,
      textTransform: 'uppercase'
    },
    input: {
      fontSize: '0.95rem',
      padding: '0.6rem 0.8rem',
      backgroundColor: 'rgba(255, 255, 255, 0.98)',
      border: '1px solid rgba(255, 215, 0, 0.5)',
      color: '#333333',
      borderRadius: '10px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
      transition: 'all 0.3s ease',
      ...letterStyle
    },
    tripTypeBox: {
      padding: '0.6rem',
      fontSize: '0.95rem',
      backgroundColor: 'rgba(255, 255, 255, 0.98)',
      border: '1px solid rgba(255, 215, 0, 0.5)',
      color: '#333333',
      borderRadius: '10px',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
      ...boldStyle,
      textTransform: 'uppercase'
    },
    button: {
      fontSize: '1.1rem',
      padding: '0.8rem 1rem',
      backgroundColor: '#b0062bff',
      border: 'none',
      color: '#FFFFFF',
      fontWeight: '700',
      borderRadius: '10px',
      boxShadow: '0 8px 25px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.6) inset',
      transition: 'all 0.3s ease',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      ...boldStyle
    },
    fareBox: {
      padding: '0.8rem',
      fontSize: '0.95rem',
      backgroundColor: 'rgba(255, 255, 255, 0.98)',
      border: '1px solid rgba(255, 215, 0, 0.5)',
      borderRadius: '10px',
      color: '#333333',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      ...letterStyle
    },
    suggestionList: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: 'white',
      border: '1px solid #ddd',
      borderRadius: '8px',
      maxHeight: '200px',
      overflowY: 'auto',
      zIndex: 1000,
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    },
    suggestionItem: {
      padding: '8px 12px',
      cursor: 'pointer',
      borderBottom: '1px solid #eee',
      transition: 'background-color 0.2s ease',
      ...letterStyle
    },
    mobileStyles: `
      /* Desktop and Tablet Default */
      .hero-section {
        position: relative;
        min-height: 100vh;
        overflow: hidden;
        display: flex;
        align-items: center;
        padding: 60px 0 60px;
      }

      .hero-banner {
        position: absolute;
        inset: 0;
        z-index: 0;
      }

      .hero-bg-slide {
        position: absolute;
        inset: 0;
        opacity: 0;
        transition: opacity 1s ease-in-out;
        z-index: 0;
      }

      .hero-bg-slide.is-active {
        opacity: 1;
        z-index: 1;
      }

      .hero-bg-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        display: block;
      }

      .hero-banner-text {
        display: none;
      }

      .hero-bg-overlay {
        position: absolute;
        inset: 0;
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 0.55) 0%,
          rgba(0, 0, 0, 0.35) 45%,
          rgba(0, 0, 0, 0.45) 100%
        );
        z-index: 2;
        pointer-events: none;
      }

      .hero-row {
        display: flex;
        align-items: flex-start;
        position: relative;
        z-index: 3;
      }

      .hero-col-text {
        padding-top: 30px;
        padding-bottom: 30px;
      }

      .hero-headline-sub {
        color: #ffffff;
        font-size: clamp(1.75rem, 3.6vw, 2.75rem);
        font-weight: 700;
        letter-spacing: 0.08em;
        margin-bottom: 0.5rem;
        text-shadow: 2px 2px 8px rgba(0,0,0,0.55);
        text-transform: uppercase;
      }

      .hero-headline-main {
        color: #ffffff;
        font-size: clamp(2.2rem, 5vw, 4.4rem);
        font-weight: 900;
        line-height: 1.1;
        margin-bottom: 0.85rem;
        text-shadow: 3px 3px 12px rgba(0,0,0,0.6);
        text-transform: uppercase;
        white-space: nowrap;
      }

      .hero-headline-accent {
        color: #FFD700;
        font-size: clamp(1.2rem, 2.8vw, 1.85rem);
        font-weight: 800;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        text-shadow: 2px 2px 6px rgba(0,0,0,0.55);
        margin-bottom: 0;
      }
      
      .destination-card {
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        cursor: pointer;
      }
      
      .destination-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0,0,0,0.15) !important;
      }

      .route-card-carousel .carousel,
      .route-card-carousel .carousel-inner,
      .route-card-carousel .carousel-item {
        height: 100%;
      }

      .route-card-carousel .carousel-indicators {
        margin-bottom: 0.4rem;
      }

      .route-card-carousel .carousel-indicators [data-bs-target] {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #FFD700;
      }

      .route-card-carousel .carousel-control-prev,
      .route-card-carousel .carousel-control-next {
        width: 12%;
        opacity: 0.75;
      }

      .tariff-match-card {
        max-width: 420px;
        margin: 0 auto;
      }

      .tariff-cards-slider-wrap .tariff-match-card {
        max-width: none;
        height: 100%;
      }

      .tariff-cards-slider-wrap {
        display: none;
      }

      @media (min-width: 992px) {
        .tariff-cards-grid {
          display: none !important;
        }

        .tariff-cards-slider-wrap {
          display: block;
          position: relative;
          padding: 0 48px;
        }

        .tariff-cards-viewport {
          overflow: hidden;
          padding: 8px 4px 16px;
          width: 100%;
        }

        .tariff-cards-track {
          display: flex;
          gap: 1rem;
          will-change: transform;
        }

        .tariff-cards-track.is-animating {
          transition: transform 0.45s ease;
        }

        .tariff-slide-item {
          flex: 0 0 calc((100% - 2rem) / 3);
          width: calc((100% - 2rem) / 3);
          max-width: calc((100% - 2rem) / 3);
          min-width: calc((100% - 2rem) / 3);
          box-sizing: border-box;
        }

        .tariff-slide-item .tariff-match-card {
          max-width: none;
          height: 100%;
        }

        .tariff-slider-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 5;
          width: 42px;
          height: 42px;
          border-radius: 50%;
          border: none;
          background: #1e88e5;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 14px rgba(0,0,0,0.2);
          cursor: pointer;
        }

        .tariff-slider-btn:hover {
          background: #1976d2;
        }

        .tariff-slider-btn-prev {
          left: 0;
        }

        .tariff-slider-btn-next {
          right: 0;
        }
      }

      .tariff-match-image-wrap {
        background: #ffffff;
      }

      .tariff-match-image-box {
        width: 100%;
        height: 210px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 16px 28px;
      }

      .tariff-match-image {
        max-width: 100%;
        max-height: 180px;
        width: auto;
        height: auto;
        object-fit: contain;
      }

      .tariff-match-carousel .carousel-indicators {
        margin-bottom: 0.35rem;
      }

      .tariff-match-carousel .carousel-indicators [data-bs-target] {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: #c0c0c0;
      }

      .tariff-match-body {
        padding: 1.1rem 1.15rem 1.25rem !important;
      }

      .tariff-match-title {
        text-align: center;
        color: #0a2540;
        font-size: 1.7rem;
        font-weight: 800;
        margin: 0 0 0.9rem;
        letter-spacing: -0.02em;
      }

      .tariff-match-rates {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        margin-bottom: 1rem;
      }

      .tariff-match-rate-box {
        background: #f0f0f0;
        border-radius: 10px;
        padding: 12px 10px;
        text-align: center;
      }

      .tariff-match-rate-label {
        display: block;
        color: #8a8a8a;
        font-size: 0.82rem;
        font-weight: 500;
        margin-bottom: 4px;
      }

      .tariff-match-rate-oneway {
        display: block;
        color: #1e88e5;
        font-size: 1.25rem;
        font-weight: 800;
      }

      .tariff-match-rate-round {
        display: block;
        color: #43a047;
        font-size: 1.25rem;
        font-weight: 800;
      }

      .tariff-match-specs {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 6px;
        text-align: center;
        margin-bottom: 1.15rem;
      }

      .tariff-match-spec-label {
        display: block;
        color: #8a8a8a;
        font-size: 0.78rem;
        font-weight: 500;
        margin-bottom: 2px;
      }

      .tariff-match-spec-value {
        display: block;
        color: #0a2540;
        font-size: 0.86rem;
        font-weight: 700;
        line-height: 1.25;
        white-space: nowrap;
      }

      .tariff-match-actions {
        display: grid;
        gap: 10px;
      }

      .tariff-match-btn-book {
        width: 100%;
        border: none;
        border-radius: 10px;
        background: #1e88e5;
        color: #fff;
        font-weight: 700;
        font-size: 1rem;
        padding: 12px 14px;
        cursor: pointer;
      }

      .tariff-match-btn-book:hover {
        background: #1976d2;
      }

      .tariff-match-btn-call {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        border-radius: 10px;
        background: #ffc107;
        color: #111;
        font-weight: 700;
        font-size: 0.98rem;
        padding: 12px 14px;
        text-decoration: none;
      }

      .tariff-match-btn-call:hover {
        background: #ffb300;
        color: #111;
      }
      
      .spot-tag {
        display: inline-block;
        background: rgba(255,255,255,0.2);
        border-radius: 20px;
        padding: 4px 12px;
        font-size: 0.75rem;
        margin-right: 8px;
        margin-bottom: 8px;
      }
      
      .suggestions-container {
        position: relative;
      }
      
      .suggestions-list {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 1000;
        max-height: 200px;
        overflow-y: auto;
      }
      
      .suggestion-item {
        padding: 8px 12px;
        cursor: pointer;
        transition: background 0.2s;
      }
      
      .suggestion-item:hover {
        background: #f0f0f0;
      }
      
      /* Mobile: image + headline first, then booking form below */
      @media (max-width: 991px) {
        .hero-section {
          min-height: auto;
          padding: 0 0 28px;
          display: block;
          background-color: #ffffff;
        }

        .hero-banner {
          position: relative;
          inset: auto;
          width: 100%;
          background-color: #ffffff;
        }

        .hero-bg-slide {
          inset: 0;
        }

        .hero-bg-slide.is-active {
          position: relative;
        }

        .hero-bg-img {
          width: 100%;
          height: auto;
          object-fit: contain;
          object-position: center top;
        }

        .hero-bg-overlay {
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.38) 0%,
            rgba(0, 0, 0, 0.18) 50%,
            rgba(0, 0, 0, 0.42) 100%
          );
        }

        .hero-banner-text {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          position: absolute;
          inset: 0;
          z-index: 3;
          padding: 88px 16px 24px;
          pointer-events: none;
        }

        .hero-row {
          flex-direction: column;
          padding-top: 18px;
        }

        .hero-col-text {
          display: none !important;
        }

        .hero-headline-wrap {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }

        .hero-headline-sub {
          font-size: clamp(1.05rem, 4.2vw, 1.45rem) !important;
        }

        .hero-headline-main {
          white-space: normal;
          font-size: clamp(1.85rem, 8.5vw, 2.7rem) !important;
        }

        .hero-headline-accent {
          font-size: clamp(0.95rem, 3.8vw, 1.25rem) !important;
        }

        .hero-col-form {
          order: 2 !important;
          width: 100% !important;
          margin-bottom: 0 !important;
          padding-top: 0 !important;
          position: relative;
          z-index: 3;
        }
        
        .form-card {
          max-width: 100% !important;
          margin: 0 auto !important;
        }
      }
      
      @media (max-width: 768px) {
        .hero-section {
          padding: 0 0 24px;
        }

        .form-card-body {
          padding: 1.2rem !important;
        }
        
        .form-title {
          font-size: 1.4rem !important;
          font-weight: 700 !important;
        }
        
        .form-label {
          font-size: 0.9rem !important;
        }
        
        .form-input {
          font-size: 0.95rem !important;
          padding: 0.5rem 0.7rem !important;
        }
        
        .trip-type-box {
          padding: 0.5rem !important;
          font-size: 0.9rem !important;
          font-weight: 700 !important;
        }
        
        .fare-box {
          padding: 0.7rem !important;
          font-size: 0.9rem !important;
        }
        
        .submit-button {
          font-size: 0.95rem !important;
          padding: 6px 8px 6px 6px !important;
          min-height: 52px;
        }

        .premium-book-icon {
          width: 34px;
          height: 34px;
        }

        .premium-book-text {
          font-size: 0.95rem;
        }
        
        .row {
          margin-left: -5px !important;
          margin-right: -5px !important;
        }
        
        .col, [class*="col-"] {
          padding-left: 5px !important;
          padding-right: 5px !important;
        }
        
        h2 {
          font-size: 1.8rem !important;
          font-weight: 700 !important;
        }
        
        .destination-card .card-body {
          padding: 1.2rem !important;
        }
        
        .destination-card h4 {
          font-size: 1.3rem !important;
        }
        
        .destination-card .btn {
          font-size: 0.85rem !important;
          padding: 8px 12px !important;
        }
        
        .floating-icon {
          width: 65px !important;
          height: 65px !important;
          font-size: 35px !important;
          bottom: 80px !important;
        }
        
        .floating-icon.whatsapp-icon {
          left: 15px !important;
          bottom: 80px !important;
        }
        
        .floating-icon.phone-icon {
          right: 15px !important;
          bottom: 80px !important;
        }
        
        .floating-icon .whatsapp-tooltip,
        .floating-icon .phone-tooltip {
          display: none !important;
        }
      }
      
      @media (max-width: 480px) {
        .carousel-container {
          height: 310px !important;
        }
        
        .carousel-caption h3 {
          font-size: 1rem !important;
        }
        
        .carousel-caption p {
          font-size: 0.8rem !important;
        }
        
        .form-card-body {
          padding: 1rem !important;
        }
        
        .form-title {
          font-size: 1.3rem !important;
        }
        
        .d-flex.gap-3 {
          gap: 0.5rem !important;
        }
        
        .col-6 {
          flex: 0 0 50%;
          max-width: 50%;
        }
        
        .floating-icon {
          width: 65px !important;
          height: 65px !important;
          font-size: 32px !important;
           bottom: 70px !important;
        }
        
        .destination-card .popular-spots {
          font-size: 0.7rem !important;
        }
        
        .destination-card .spot-tag {
          font-size: 0.65rem !important;
          padding: 2px 8px !important;
        }
      }
      
      /* Apply consistent font to all elements */
      * {
        font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
      }
      
      h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
        font-weight: 700 !important;
        letter-spacing: -0.03em !important;
      }
      
      p, span, div, small, strong, li {
        font-weight: 500 !important;
        letter-spacing: -0.02em !important;
        line-height: 1.5 !important;
      }
      
      .text-warning, .text-white, .text-dark, .text-secondary {
        font-weight: inherit !important;
      }
      
      /* Animations */
      @keyframes sparkle {
        0%, 100% { 
          opacity: 0.2; 
          transform: scale(1); 
        }
        50% { 
          opacity: 0.8; 
          transform: scale(1.5); 
          box-shadow: 0 0 15px rgba(255, 215, 0, 0.8);
        }
      }
      
      @keyframes shineMove {
        0% {
          transform: translateX(-100%) rotate(25deg);
        }
        20% {
          transform: translateX(100%) rotate(25deg);
        }
        100% {
          transform: translateX(200%) rotate(25deg);
        }
      }
      
      @keyframes softPulse {
        0%, 100% {
          box-shadow: 0 30px 60px rgba(139, 0, 0, 0.6), 0 0 0 2px rgba(255, 215, 0, 0.3) inset;
        }
        50% {
          box-shadow: 0 35px 70px rgba(139, 0, 0, 0.7), 0 0 0 3px rgba(255, 215, 0, 0.4) inset;
        }
      }
      
      .form-card {
        animation: softPulse 4s infinite ease-in-out;
        will-change: box-shadow;
      }
      
      .form-card::before {
        content: '';
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: linear-gradient(
          115deg,
          transparent 30%,
          rgba(255, 255, 255, 0.15) 35%,
          rgba(255, 215, 0, 0.2) 40%,
          rgba(255, 215, 0, 0.3) 45%,
          rgba(255, 215, 0, 0.4) 50%,
          rgba(255, 215, 0, 0.3) 55%,
          rgba(255, 215, 0, 0.2) 60%,
          rgba(255, 255, 255, 0.15) 65%,
          transparent 70%
        );
        transform: rotate(25deg);
        animation: shineMove 8s infinite;
        pointer-events: none;
        z-index: 5;
        opacity: 0.4;
        will-change: transform;
      }
      
      .form-card:hover {
        animation: none;
        box-shadow: 0 35px 70px rgba(139, 0, 0, 0.8), 0 0 0 4px rgba(255, 215, 0, 0.5) inset !important;
        transition: box-shadow 0.3s ease;
      }
      
      .form-input:focus {
        border-color: #FFD700 !important;
        box-shadow: 0 0 0 0.2rem rgba(255, 215, 0, 0.3) !important;
        transform: translateY(-1px);
        transition: all 0.2s ease;
      }
      
      .submit-button.premium-book-btn {
        position: relative;
        overflow: visible;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        width: 100%;
        min-height: 58px;
        padding: 8px 10px 8px 8px !important;
        border: 3px solid #d4af37 !important;
        border-radius: 999px !important;
        background:
          linear-gradient(180deg, rgba(255,255,255,0.18) 0%, transparent 42%),
          linear-gradient(180deg, #0d1b3a 0%, #050914 55%, #000000 100%) !important;
        color: #fff !important;
        box-shadow:
          0 0 0 2px #1ee0ff inset,
          0 8px 22px rgba(0,0,0,0.45),
          0 0 18px rgba(212,175,55,0.45) !important;
        text-transform: none !important;
        letter-spacing: 0.04em;
        transform: none !important;
      }

      .submit-button.premium-book-btn:hover,
      .submit-button.premium-book-btn:focus {
        background:
          linear-gradient(180deg, rgba(255,255,255,0.22) 0%, transparent 42%),
          linear-gradient(180deg, #12244c 0%, #07101f 55%, #000000 100%) !important;
        box-shadow:
          0 0 0 2px #4aecff inset,
          0 10px 26px rgba(0,0,0,0.5),
          0 0 22px rgba(255,215,0,0.55) !important;
        transform: translateY(-1px) !important;
      }

      .submit-button.premium-book-btn:disabled {
        opacity: 0.75;
        transform: none !important;
      }

      .submit-button.premium-book-btn::before {
        display: none;
      }

      .premium-book-icon {
        width: 40px;
        height: 40px;
        flex-shrink: 0;
        border-radius: 50%;
        background: radial-gradient(circle at 30% 25%, #fff3b0 0%, #ffd700 38%, #b8860b 100%);
        color: #111;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 6px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.55);
      }

      .premium-book-label {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        line-height: 1.1;
      }

      .premium-book-text {
        font-weight: 800;
        font-size: 1.05rem;
        text-transform: none;
      }

      .premium-book-text .gold {
        color: #FFD700;
      }

      .premium-book-text .white {
        color: #ffffff;
      }

      .premium-book-swoosh {
        width: 78px;
        height: 7px;
        margin-top: 3px;
        border-radius: 50%;
        border-bottom: 2px solid #FFD700;
        opacity: 0.9;
      }
      
      @keyframes buttonShine {
        0% {
          transform: rotate(45deg) translateX(-100%);
        }
        100% {
          transform: rotate(45deg) translateX(100%);
        }
      }
      
      .trip-type-box:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 15px rgba(0,0,0,0.2), 0 0 0 1px #FFD700 inset !important;
        border-color: #FFD700 !important;
        transition: all 0.2s ease;
      }
      
      .route-image {
        transition: transform 0.4s ease;
      }
      
      .route-image:hover {
        transform: scale(1.05);
      }
      
      .carousel .carousel-indicators {
        margin-bottom: 0.5rem;
      }
      
      .carousel .carousel-indicators button {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin: 0 4px;
      }
      
      .carousel .carousel-control-prev,
      .carousel .carousel-control-next {
        width: 10%;
        opacity: 0;
        transition: opacity 0.2s ease;
      }
      
      .carousel-container:hover .carousel-control-prev,
      .carousel-container:hover .carousel-control-next {
        opacity: 1;
      }
      
      .carousel .carousel-caption {
        padding: 10px;
        background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
        left: 0;
        right: 0;
        bottom: 0;
        text-align: left;
      }
      
      @media (max-width: 768px) {
        .row > .col-6 {
          flex: 0 0 50%;
          max-width: 50%;
        }
      }
      
      @media (max-width: 480px) {
        .row > .col-6 {
          flex: 0 0 50%;
          max-width: 50%;
        }
      }
      
      .g-3 {
        --bs-gutter-x: 1rem;
        --bs-gutter-y: 1rem;
      }
      
      @keyframes mobile-pulse {
        0%, 100% {
          transform: translateY(-50%) scale(1);
        }
        50% {
          transform: translateY(-50%) scale(1.05);
        }
      }
      
      .floating-icon {
        will-change: transform;
      }
    `
  };

  return (
    <div className="fade-in">
      <style>{formStyles.mobileStyles}</style>

      {/* FLOATING WHATSAPP AND PHONE ICONS */}
      <a 
        href={`https://wa.me/${CLIENT_WHATSAPP_NUMBER}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-icon whatsapp-icon"
        style={{
          position: 'fixed',
          left: '20px',
          bottom: '100px',
          transform: 'translateY(-50%)',
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          backgroundColor: '#25d366',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '30px',
          boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)',
          cursor: 'pointer',
          zIndex: 1000,
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          textDecoration: 'none',
          animation: 'mobile-pulse 3s infinite',
          willChange: 'transform'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-50%) scale(1.05)';
          e.currentTarget.style.boxShadow = '0 8px 25px rgba(37, 211, 102, 0.6)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 15px rgba(37, 211, 102, 0.4)';
        }}
      >
        <FaWhatsapp />
        <span style={{
          position: 'absolute',
          left: '70px',
          backgroundColor: '#25d366',
          color: 'white',
          padding: '5px 15px',
          borderRadius: '20px',
          fontSize: '14px',
          whiteSpace: 'nowrap',
          opacity: 0,
          visibility: 'hidden',
          transition: 'opacity 0.2s ease',
          boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
          ...letterStyle
        }} className="whatsapp-tooltip">
          WhatsApp Us
        </span>
      </a>

      <a 
        href={`tel:+${CLIENT_PHONE_NUMBER}`}
        className="floating-icon phone-icon"
        style={{
          position: 'fixed',
          right: '20px',
          bottom: '100px', 
          transform: 'translateY(-50%)',
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          backgroundColor: '#ffc107',
          color: 'black',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '30px',
          boxShadow: '0 4px 15px rgba(255, 193, 7, 0.4)',
          cursor: 'pointer',
          zIndex: 1000,
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          textDecoration: 'none',
          animation: 'mobile-pulse 3s infinite 0.5s',
          willChange: 'transform'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-50%) scale(1.05)';
          e.currentTarget.style.boxShadow = '0 8px 25px rgba(255, 193, 7, 0.6)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 15px rgba(255, 193, 7, 0.4)';
        }}
      >
        <FaPhone />
        <span style={{
          position: 'absolute',
          right: '70px',
          backgroundColor: '#ffc107',
          color: 'black',
          padding: '5px 15px',
          borderRadius: '20px',
          fontSize: '14px',
          whiteSpace: 'nowrap',
          opacity: 0,
          visibility: 'hidden',
          transition: 'opacity 0.2s ease',
          boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
          ...letterStyle
        }} className="phone-tooltip">
          Call Us Now
        </span>
      </a>

      {/* Hero Section — scenic background + form (unchanged) + headline */}
      <section className="hero-section">
        <div className="hero-banner">
          {carouselImages.map((image, index) => (
            <div
              key={index}
              className={`hero-bg-slide${index === currentSlide ? ' is-active' : ''}`}
            >
              <img
                src={`/${image.url}`}
                alt={image.title}
                className="hero-bg-img"
                decoding="async"
                loading={index === 0 ? 'eager' : 'lazy'}
              />
            </div>
          ))}
          <div className="hero-bg-overlay" />
          <div className="hero-banner-text">
            <div className="hero-headline-wrap">
              <p className="hero-headline-sub" style={headingStyle}>RIDE SAFE WITH</p>
              <h1 className="hero-headline-main" style={headingStyle}>LEXUS DROP TAXI</h1>
              <p className="hero-headline-accent" style={boldStyle}>ONE WAY &amp; ROUND TRIP CABS</p>
            </div>
          </div>
        </div>

        <Container>
          <Row className="hero-row g-4 align-items-start">
            <Col lg={6} className="hero-col-form">
              <Card 
                className="border-0 shadow-lg form-card" 
                style={{
                  ...formStyles.card,
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                {generateSparkles()}
                
                <Card.Body className="form-card-body" style={formStyles.cardBody}>
                  <h3 className="text-center fw-bold mb-4 form-title" style={formStyles.title}>
                    <span style={{ color: '#FFFFFF', ...headingStyle }}>Lexus-Drop</span>{' '}
                    <span style={{ color: '#FFFFFF', ...headingStyle }}>Taxi</span>
                  </h3>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="fw-bold form-label" style={formStyles.label}>
                        <FaRoad className="me-1" style={{ color: '#FFFFFF' }} size={12} />
                        Trip Type
                      </label>
                      <div className="d-flex gap-3">
                        <div 
                          className={`flex-fill border rounded text-center trip-type-box ${formData.tripType === 'one-way' ? 'active' : ''}`}
                          style={{ 
                            ...formStyles.tripTypeBox, 
                            cursor: 'pointer',
                            backgroundColor: formData.tripType === 'one-way' ? '#FFD700' : 'rgba(0, 0, 0, 0.18)',
                            border: formData.tripType === 'one-way' ? '2px solid #FFFFFF' : '2px solid rgba(255, 255, 255, 0.35)',
                            boxShadow: formData.tripType === 'one-way'
                              ? '0 4px 14px rgba(0,0,0,0.35), 0 0 0 2px rgba(255,215,0,0.5)'
                              : 'none',
                            color: formData.tripType === 'one-way' ? '#1a1a1a' : 'rgba(255, 255, 255, 0.85)',
                            transform: formData.tripType === 'one-way' ? 'scale(1.02)' : 'scale(1)',
                          }}
                          onClick={() => {
                            setFormData({...formData, tripType: 'one-way', returnDate: ''});
                            if (formData.carType && calculatedDistance > 0) {
                              updateFareWithDistance(calculatedDistance);
                            }
                          }}
                        >
                          <strong style={{
                            fontSize: '1.1rem',
                            letterSpacing: '0px',
                            ...boldStyle,
                            color: formData.tripType === 'one-way' ? '#1a1a1a' : 'rgba(255, 255, 255, 0.9)'
                          }}>ONE WAY</strong>
                        </div>
                        <div 
                          className={`flex-fill border rounded text-center trip-type-box ${formData.tripType === 'round-trip' ? 'active' : ''}`}
                          style={{ 
                            ...formStyles.tripTypeBox, 
                            cursor: 'pointer',
                            backgroundColor: formData.tripType === 'round-trip' ? '#FFD700' : 'rgba(0, 0, 0, 0.18)',
                            border: formData.tripType === 'round-trip' ? '2px solid #FFFFFF' : '2px solid rgba(255, 255, 255, 0.35)',
                            boxShadow: formData.tripType === 'round-trip'
                              ? '0 4px 14px rgba(0,0,0,0.35), 0 0 0 2px rgba(255,215,0,0.5)'
                              : 'none',
                            color: formData.tripType === 'round-trip' ? '#1a1a1a' : 'rgba(255, 255, 255, 0.85)',
                            transform: formData.tripType === 'round-trip' ? 'scale(1.02)' : 'scale(1)',
                          }}
                          onClick={() => {
                            setFormData({...formData, tripType: 'round-trip'});
                            if (formData.carType && calculatedDistance > 0) {
                              updateFareWithDistance(calculatedDistance);
                            }
                          }}
                        >
                          <strong style={{
                            fontSize: '1.1rem',
                            letterSpacing: '0px',
                            ...boldStyle,
                            color: formData.tripType === 'round-trip' ? '#1a1a1a' : 'rgba(255, 255, 255, 0.9)'
                          }}>ROUND TRIP</strong>
                        </div>
                      </div>
                    </div>

                    <div className="mb-2 position-relative">
                      <label className="fw-bold form-label" style={formStyles.label}>
                        <FaMapMarkerAlt className="me-1" style={{ color: '#FFFFFF' }} size={12} />
                        Pickup Location *
                      </label>
                      <input
                        type="text"
                        name="pickupLocation"
                        value={formData.pickupLocation}
                        onChange={handlePickupChange}
                        onFocus={() => formData.pickupLocation.length >= 2 && setShowPickupSuggestions(true)}
                        onBlur={() => setTimeout(() => setShowPickupSuggestions(false), 200)}
                        className="form-control form-input"
                        style={formStyles.input}
                        placeholder="Enter Pickup Location (India)"
                        required
                      />
                      {showPickupSuggestions && pickupSuggestions.length > 0 && (
                        <div className="suggestions-list" style={formStyles.suggestionList}>
                          {pickupSuggestions.map((place, idx) => (
                            <div
                              key={idx}
                              className="suggestion-item"
                              style={formStyles.suggestionItem}
                              onClick={() => selectPickupSuggestion(place)}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                            >
                              {place.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="mb-2 position-relative">
                      <label className="fw-bold form-label" style={formStyles.label}>
                        <FaMapMarkerAlt className="me-1" style={{ color: '#FFFFFF' }} size={12} />
                        Drop Location *
                      </label>
                      <input
                        type="text"
                        name="dropLocation"
                        value={formData.dropLocation}
                        onChange={handleDropChange}
                        onFocus={() => formData.dropLocation.length >= 2 && setShowDropSuggestions(true)}
                        onBlur={() => setTimeout(() => setShowDropSuggestions(false), 200)}
                        className="form-control form-input"
                        style={formStyles.input}
                        placeholder="Enter Drop Location (India)"
                        required
                      />
                      {showDropSuggestions && dropSuggestions.length > 0 && (
                        <div className="suggestions-list" style={formStyles.suggestionList}>
                          {dropSuggestions.map((place, idx) => (
                            <div
                              key={idx}
                              className="suggestion-item"
                              style={formStyles.suggestionItem}
                              onClick={() => selectDropSuggestion(place)}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                            >
                              {place.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {formData.tripType === 'one-way' && (distanceLoading || (calculatedDistance > 0 && formData.pickupLocation && formData.dropLocation)) && (
                      <div className="mb-2 text-center">
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            backgroundColor: '#2f3328',
                            color: '#FFFFFF',
                            padding: '6px 16px',
                            borderRadius: '999px',
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
                            ...letterStyle
                          }}
                        >
                          <FaMapMarkerAlt size={14} style={{ color: '#ff4d8d' }} />
                          {distanceLoading
                            ? 'Calculating distance...'
                            : `Distance: ${calculatedDistance} km`}
                        </span>
                      </div>
                    )}

                    <div className="mb-2">
                      <label className="fw-bold form-label" style={formStyles.label}>
                        <FaUser className="me-1" style={{ color: '#FFFFFF' }} size={12} />
                        Name *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-control form-input"
                        style={formStyles.input}
                        placeholder="Enter Your Name"
                        required
                      />
                    </div>

                    <div className="mb-2">
                      <label className="fw-bold form-label" style={formStyles.label}>
                        <FaPhone className="me-1" style={{ color: '#FFFFFF' }} size={12} />
                        Mobile *
                      </label>
                      <input
                        type="tel"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        className="form-control form-input"
                        style={formStyles.input}
                        placeholder="Enter Mobile Number"
                        required
                        maxLength="10"
                        pattern="[0-9]{10}"
                      />
                    </div>

                    <Row className="mb-2">
                      <Col xs={6}>
                        <label className="fw-bold form-label" style={formStyles.label}>
                          <FaCalendarAlt className="me-1" style={{ color: '#FFFFFF' }} size={12} />
                          {formData.tripType === 'round-trip' ? 'Pickup Date *' : 'Date *'}
                        </label>
                        <input
                          type="date"
                          name="pickupDate"
                          value={formData.pickupDate}
                          onChange={handleChange}
                          className="form-control form-input"
                          style={formStyles.input}
                          min={new Date().toISOString().split('T')[0]}
                          required
                        />
                      </Col>
                      <Col xs={6}>
                        <label className="fw-bold form-label" style={formStyles.label}>
                          <FaClock className="me-1" style={{ color: '#FFFFFF' }} size={12} />
                          Time *
                        </label>
                        <input
                          type="time"
                          name="pickupTime"
                          value={formData.pickupTime}
                          onChange={handleChange}
                          className="form-control form-input"
                          style={formStyles.input}
                          required
                        />
                      </Col>
                    </Row>

                    {formData.tripType === 'round-trip' && (
                      <Row className="mb-2">
                        <Col xs={6}>
                          <label className="fw-bold form-label" style={formStyles.label}>
                            <FaCalendarAlt className="me-1" style={{ color: '#FFFFFF' }} size={12} />
                            Return Date *
                          </label>
                          <input
                            type="date"
                            name="returnDate"
                            value={formData.returnDate}
                            onChange={handleChange}
                            className="form-control form-input"
                            style={formStyles.input}
                            min={formData.pickupDate || new Date().toISOString().split('T')[0]}
                            required
                          />
                        </Col>
                      </Row>
                    )}
 
                    <div className="mb-3">
                      <label className="fw-bold form-label mb-2" style={{ ...formStyles.label, fontSize: '1rem' }}>
                        <FaCar className="me-1" style={{ color: '#FFFFFF' }} size={12} />
                        Select Car Type *
                      </label>

                      {(() => {
                        const formCarOptions = [
                          { name: 'SEDAN', image: '/images/form/sedan.png', oneWay: 15, roundTrip: 14 },
                          { name: 'ETIOS', image: '/images/form/etios.png', oneWay: 16, roundTrip: 15 },
                          { name: 'MUV', image: '/images/form/muv.png', oneWay: 20, roundTrip: 19 },
                          { name: 'INNOVA', image: '/images/form/innova.png', oneWay: 21, roundTrip: 20 },
                          { name: 'CRYSTA', image: '/images/form/crysta.png', oneWay: 24, roundTrip: 23 }
                        ];

                        const renderCarCard = (opt) => {
                          const carData = cars.find((c) => c.name === opt.name);
                          const rate = formData.tripType === 'round-trip'
                            ? (carData?.roundTripRate ?? opt.roundTrip)
                            : (carData?.oneWayRate ?? opt.oneWay);
                          const isSelected = formData.carType === opt.name;

                          return (
                            <Col xs={4} key={opt.name}>
                              <div
                                className={`car-option ${isSelected ? 'selected' : ''}`}
                                style={{
                                  border: `2px solid ${isSelected ? '#FFD700' : '#dee2e6'}`,
                                  borderRadius: '10px',
                                  padding: '8px 6px',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: isSelected ? '#1388e9dd' : 'white',
                                  height: '100%',
                                  boxShadow: isSelected
                                    ? '0 6px 14px rgba(255,215,0,0.35)'
                                    : '0 2px 8px rgba(0,0,0,0.08)',
                                  transform: isSelected ? 'translateY(-1px)' : 'none'
                                }}
                                onClick={() => selectCar(opt.name)}
                              >
                                <img
                                  src={opt.image}
                                  alt={opt.name}
                                  style={{
                                    width: '65%',
                                    maxWidth: '64px',
                                    height: '38px',
                                    objectFit: 'contain',
                                    display: 'block',
                                    margin: '0 auto 4px',
                                    borderRadius: '4px',
                                    border: 'none'
                                  }}
                                  className="car-image"
                                  loading="lazy"
                                />
                                <div
                                  className="fw-bold text-center car-name"
                                  style={{
                                    color: isSelected ? '#f7f4f4ff' : '#333333',
                                    ...boldStyle,
                                    fontSize: '0.78rem',
                                    lineHeight: 1.2
                                  }}
                                >
                                  {opt.name}
                                </div>
                                <div
                                  className="fw-bold text-center car-price"
                                  style={{
                                    color: isSelected ? '#FFD700' : '#8B0000',
                                    ...boldStyle,
                                    fontSize: '0.75rem',
                                    lineHeight: 1.2
                                  }}
                                >
                                  ₹<OptimizedNumber num={rate} />/km
                                </div>
                              </div>
                            </Col>
                          );
                        };

                        return (
                          <>
                            <Row className="g-2 justify-content-center mb-2">
                              {formCarOptions.slice(0, 2).map(renderCarCard)}
                            </Row>
                            <Row className="g-2">
                              {formCarOptions.slice(2).map(renderCarCard)}
                            </Row>
                          </>
                        );
                      })()}
                    </div>

                    {fareEstimate && (
                      <div className="bg-light rounded mb-3 fare-box" style={formStyles.fareBox}>
                        {formData.tripType === 'one-way' ? (
                          <div className="d-flex justify-content-between mb-1">
                            <span style={letterStyle}>Distance:</span>
                            <span className="fw-bold" style={{ color: '#8B0000', ...boldStyle }}>
                              <OptimizedNumber num={fareEstimate.billableDistance} /> km
                              {fareEstimate.actualDistance < 130 ? ' (min 130)' : ''}
                            </span>
                          </div>
                        ) : (
                          <div className="d-flex justify-content-between mb-1">
                            <span style={letterStyle}>Trip Plan:</span>
                            <span className="fw-bold text-end" style={{ color: '#8B0000', ...boldStyle }}>
                              <OptimizedNumber num={fareEstimate.tripDays} /> day(s) x 250 km = <OptimizedNumber num={fareEstimate.billableDistance} /> km
                            </span>
                          </div>
                        )}
                        <div className="d-flex justify-content-between mb-1">
                          <span style={letterStyle}>Base Fare (@ ₹<OptimizedNumber num={fareEstimate.rate} />/km):</span>
                          <span className="fw-bold" style={{ color: '#8B0000', ...boldStyle }}>₹<OptimizedNumber num={fareEstimate.baseFare} /></span>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                          <span style={letterStyle}>
                            {formData.tripType === 'round-trip' && fareEstimate.tripDays > 1
                              ? `Driver Bata (${fareEstimate.tripDays} x ₹${fareEstimate.bataPerDay || 400}):`
                              : 'Driver Bata:'}
                          </span>
                          <span className="fw-bold" style={{ color: '#8B0000', ...boldStyle }}>₹<OptimizedNumber num={fareEstimate.driverBata} /></span>
                        </div>
                        <hr className="my-1" />
                        <div className="d-flex justify-content-between">
                          <span className="fw-bold" style={boldStyle}>Estimated Total:</span>
                          <span className="fw-bold" style={{ color: '#8B0000', ...boldStyle, fontSize: '1.1rem' }}>₹<OptimizedNumber num={fareEstimate.total} /></span>
                        </div>
                        {formData.tripType === 'round-trip' && (
                          <small
                            className="text-muted d-block mt-1 fare-note"
                            style={{
                              fontFamily: letterStyle.fontFamily,
                              fontWeight: 500,
                              letterSpacing: 'normal',
                              lineHeight: 1.5,
                              paddingLeft: '12px',
                              textIndent: '-12px'
                            }}
                          >
                            *Package includes 250 km per day. More than 250 km/day will be charged extra @ ₹{fareEstimate.extraPerKm}/km
                          </small>
                        )}
                        {formData.tripType === 'one-way' && (
                          <small
                            className="text-muted d-block mt-1 fare-note"
                            style={{
                              fontFamily: letterStyle.fontFamily,
                              fontWeight: 500,
                              letterSpacing: 'normal',
                              lineHeight: 1.5,
                              paddingLeft: '12px',
                              textIndent: '-12px'
                            }}
                          >
                            *One way minimum running is 130 km
                          </small>
                        )}
                        <small
                          className="text-muted d-block mt-1 fare-note"
                          style={{
                            fontFamily: letterStyle.fontFamily,
                            fontWeight: 500,
                            letterSpacing: 'normal',
                            lineHeight: 1.5,
                            paddingLeft: '12px',
                            textIndent: '-12px'
                          }}
                        >
                          *Toll, permit & hill charges extra if applicable
                        </small>
                      </div>
                    )}

                    <Button
                      type="submit"
                      disabled={loading}
                      className="w-100 fw-bold submit-button premium-book-btn"
                    >
                      <span className="premium-book-icon">
                        <FaCar size={16} />
                      </span>
                      <span className="premium-book-label">
                        {loading ? (
                          <span className="premium-book-text">
                            <span className="gold">Booking...</span>
                          </span>
                        ) : (
                          <>
                            <span className="premium-book-text">
                              <span className="gold">Book</span>{' '}
                              <span className="white">Your</span>{' '}
                              <span className="gold">Cab</span>
                            </span>
                            <span className="premium-book-swoosh" />
                          </>
                        )}
                      </span>
                      <span className="premium-book-icon">
                        <FaChevronRight size={14} />
                      </span>
                    </Button>
                    
                    <p className="text-center mt-2 mb-0 small" style={{ color: '#FFFFFF', ...letterStyle }}>
                      <FaWhatsapp className="me-1" style={{ color: '#25d366' }} size={12} />
                      <FaEnvelope className="me-1" style={{ color: '#FFD700' }} size={12} />
                      WhatsApp &amp; Email sent to admin
                    </p>
                  </form>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={6} className="hero-col-text d-flex align-items-start">
              <div className="w-100 hero-headline-wrap" style={{ marginTop: '30px', marginBottom: '30px' }}>
                <p className="hero-headline-sub" style={headingStyle}>RIDE SAFE WITH</p>
                <h1 className="hero-headline-main" style={headingStyle}>LEXUS DROP TAXI</h1>
                <p className="hero-headline-accent" style={boldStyle}>ONE WAY &amp; ROUND TRIP CABS</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* SUCCESS POPUP */}
      <Modal 
        show={showSuccessPopup} 
        onHide={handlePopupClose}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="text-center p-5">
          <div className="mb-4">
            <FaCheckCircle size={80} className="text-success" />
          </div>
          <h2 className="fw-bold mb-3" style={{ 
            color: '#28a745',
            ...headingStyle,
            fontSize: '2rem'
          }}>
            Your Booking Confirmed!
          </h2>
          <p className="mb-4" style={{ 
            fontSize: '1.1rem',
            ...letterStyle,
            color: '#666'
          }}>
            Thank you for choosing Lexus Drop Taxi. Your booking has been successfully confirmed.
          </p>
          <Button 
            variant="success" 
            size="lg"
            onClick={handlePopupClose}
            className="px-5 rounded-pill"
            style={{
              ...boldStyle,
              fontSize: '1.2rem'
            }}
          >
            OK
          </Button>
        </Modal.Body>
      </Modal>

      {/* Stats Section */}
      <Container className="my-5" ref={statsRef}>
        <h2 className="text-center mb-5" style={{ 
          fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
          ...headingStyle
        }}>
          Our <span className="text-warning" style={headingStyle}>Achievements</span>
        </h2>
        <Row>
          {stats.map((stat, index) => (
            <Col md={3} sm={6} key={index} className="mb-4">
              <Card className="text-center p-4 border-0 shadow-sm h-100">
                <div className="display-1 mb-3" style={{ fontSize: 'clamp(2rem, 5vw, 3rem)' }}>{stat.icon}</div>
                <h2 className="text-warning fw-bold" style={{ 
                  fontSize: 'clamp(1.5rem, 4vw, 2.2rem)',
                  ...boldStyle
                }}>
                  {stat.isDecimal ? <OptimizedNumber num={stat.value.toFixed(1)} /> : <OptimizedNumber num={Math.round(stat.value).toLocaleString()} />}
                  {stat.suffix && <OptimizedNumber num={stat.suffix} />}
                </h2>
                <p className="text-secondary" style={{ 
                  fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                  ...letterStyle,
                  fontWeight: '500'
                }}>{stat.label}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* TARIFF SECTION */}
      <section className="py-5 bg-light">
        <Container>
          <h2 className="text-center mb-5" style={{ 
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            ...headingStyle
          }}>
            <span className="text-warning" style={headingStyle}>Outstation</span> Tariff
          </h2>
          
          {/* Mobile / tablet: stacked cards (looks good) */}
          <Row className="justify-content-center tariff-cards-grid">
            {tariffCars.map((car, index) => {
              const carImages = car.images;
              
              return (
                <Col lg={6} md={6} key={index} className="mb-4 d-flex">
                  <Card
                    className="border-0 tariff-match-card w-100"
                    style={{
                      borderRadius: '18px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                    }}
                  >
                    <div className="position-relative tariff-match-image-wrap">
                      <Carousel
                        interval={3500}
                        indicators={carImages.length > 1}
                        controls={false}
                        pause="hover"
                        className="tariff-match-carousel"
                      >
                        {carImages.map((imageObj, imgIndex) => (
                          <Carousel.Item key={imgIndex}>
                            <div className="tariff-match-image-box">
                              <img
                                src={imageObj.url}
                                alt={`${car.name} - ${imageObj.model}`}
                                className="tariff-match-image"
                                loading="lazy"
                              />
                            </div>
                          </Carousel.Item>
                        ))}
                      </Carousel>

                    </div>

                    <Card.Body className="tariff-match-body">
                      <h3 className="tariff-match-title">{car.displayName || car.name}</h3>

                      <div className="tariff-match-rates">
                        <div className="tariff-match-rate-box">
                          <span className="tariff-match-rate-label">One Way Trip</span>
                          <span className="tariff-match-rate-oneway">₹{car.oneWayRate}/km</span>
                        </div>
                        <div className="tariff-match-rate-box">
                          <span className="tariff-match-rate-label">Round Trip</span>
                          <span className="tariff-match-rate-round">₹{car.roundTripRate}/km</span>
                        </div>
                      </div>

                      <div className="tariff-match-specs">
                        <div className="tariff-match-spec">
                          <span className="tariff-match-spec-label">Capacity</span>
                          <span className="tariff-match-spec-value">{car.capacity}</span>
                        </div>
                        <div className="tariff-match-spec">
                          <span className="tariff-match-spec-label">AC</span>
                          <span className="tariff-match-spec-value">{car.ac || 'Yes'}</span>
                        </div>
                        <div className="tariff-match-spec">
                          <span className="tariff-match-spec-label">Driver Beta</span>
                          <span className="tariff-match-spec-value">₹{car.driverBata}</span>
                        </div>
                      </div>

                      <div className="tariff-match-actions">
                        <button
                          type="button"
                          className="tariff-match-btn-book"
                          onClick={() => {
                            selectCar(car.name);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          Book Now
                        </button>
                        <a
                          href={`tel:+${CLIENT_PHONE_NUMBER}`}
                          className="tariff-match-btn-call"
                        >
                          <FaPhone size={13} />
                          +91 81481 11516
                        </a>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>

          {/* Desktop web: smooth sliding carousel with loop */}
          <div className="tariff-cards-slider-wrap">
            <button
              type="button"
              className="tariff-slider-btn tariff-slider-btn-prev"
              onClick={() => scrollTariffCards(-1)}
              aria-label="Previous cars"
            >
              <FaChevronLeft />
            </button>

            <div className="tariff-cards-viewport" ref={tariffViewportRef}>
              <div
                className={`tariff-cards-track${tariffTransition ? ' is-animating' : ''}`}
                style={{
                  transform: `translateX(-${tariffIndex * tariffStepPx}px)`
                }}
              >
                {extendedTariffCars.map((car, index) => {
                  const carImages = car.images;
                  return (
                    <div
                      className="tariff-slide-item"
                      key={`track-${index}-${car.name}`}
                      style={
                        tariffCardWidthPx
                          ? {
                              flex: `0 0 ${tariffCardWidthPx}px`,
                              width: `${tariffCardWidthPx}px`,
                              maxWidth: `${tariffCardWidthPx}px`,
                              minWidth: `${tariffCardWidthPx}px`
                            }
                          : undefined
                      }
                    >
                      <Card
                        className="border-0 tariff-match-card w-100"
                        style={{
                          borderRadius: '18px',
                          overflow: 'hidden',
                          background: '#ffffff',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                        }}
                      >
                        <div className="position-relative tariff-match-image-wrap">
                          <Carousel
                            interval={3500}
                            indicators={carImages.length > 1}
                            controls={false}
                            pause="hover"
                            className="tariff-match-carousel"
                          >
                            {carImages.map((imageObj, imgIndex) => (
                              <Carousel.Item key={imgIndex}>
                                <div className="tariff-match-image-box">
                                  <img
                                    src={imageObj.url}
                                    alt={`${car.name} - ${imageObj.model}`}
                                    className="tariff-match-image"
                                    loading="lazy"
                                  />
                                </div>
                              </Carousel.Item>
                            ))}
                          </Carousel>

                        </div>

                        <Card.Body className="tariff-match-body">
                          <h3 className="tariff-match-title">{car.displayName || car.name}</h3>

                          <div className="tariff-match-rates">
                            <div className="tariff-match-rate-box">
                              <span className="tariff-match-rate-label">One Way Trip</span>
                              <span className="tariff-match-rate-oneway">₹{car.oneWayRate}/km</span>
                            </div>
                            <div className="tariff-match-rate-box">
                              <span className="tariff-match-rate-label">Round Trip</span>
                              <span className="tariff-match-rate-round">₹{car.roundTripRate}/km</span>
                            </div>
                          </div>

                          <div className="tariff-match-specs">
                            <div className="tariff-match-spec">
                              <span className="tariff-match-spec-label">Capacity</span>
                              <span className="tariff-match-spec-value">{car.capacity}</span>
                            </div>
                            <div className="tariff-match-spec">
                              <span className="tariff-match-spec-label">AC</span>
                              <span className="tariff-match-spec-value">{car.ac || 'Yes'}</span>
                            </div>
                            <div className="tariff-match-spec">
                              <span className="tariff-match-spec-label">Driver Beta</span>
                              <span className="tariff-match-spec-value">₹{car.driverBata}</span>
                            </div>
                          </div>

                          <div className="tariff-match-actions">
                            <button
                              type="button"
                              className="tariff-match-btn-book"
                              onClick={() => {
                                selectCar(car.name);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }}
                            >
                              Book Now
                            </button>
                            <a
                              href={`tel:+${CLIENT_PHONE_NUMBER}`}
                              className="tariff-match-btn-call"
                            >
                              <FaPhone size={13} />
                              +91 81481 11516
                            </a>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  );
                })}
              </div>
            </div>

            <button
              type="button"
              className="tariff-slider-btn tariff-slider-btn-next"
              onClick={() => scrollTariffCards(1)}
              aria-label="Next cars"
            >
              <FaChevronRight />
            </button>
          </div>
        </Container>
      </section>

      {/* POPULAR ROUTES SECTION */}
      <section className="py-5">
        <Container>
          <h2 className="text-center mb-5" style={{ 
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            ...headingStyle
          }}>
            <span className="text-warning" style={headingStyle}>Popular</span> Routes
          </h2>
          <Row>
            {popularRoutes.map((route, index) => (
              <Col lg={6} key={index} className="mb-4">
                <Card className="border-0 shadow h-100" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                  <div className="route-card-carousel" style={{ aspectRatio: '16 / 9', width: '100%', overflow: 'hidden' }}>
                    <Carousel
                      interval={3500}
                      indicators={route.images.length > 1}
                      controls={route.images.length > 1}
                      pause="hover"
                      fade
                    >
                      {route.images.map((img, imgIndex) => (
                        <Carousel.Item key={imgIndex}>
                          <img
                            src={img}
                            alt={`${route.from} to ${route.to} ${imgIndex + 1}`}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              display: 'block',
                              aspectRatio: '16 / 9'
                            }}
                            loading={imgIndex === 0 ? 'eager' : 'lazy'}
                          />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  </div>
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-warning text-dark rounded-circle p-2 me-3" style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span className="fs-5">{route.icon}</span>
                      </div>
                      <div>
                        <h6 className="fw-bold mb-1" style={headingStyle}>{route.from} → {route.to}</h6>
                        <small className="text-secondary" style={letterStyle}>Distance: {route.distance}</small>
                      </div>
                    </div>
                    <div className="small mb-3" style={boldStyle}>
                      <span className="fw-bold me-2" style={boldStyle}>SEDAN:</span> ₹<OptimizedNumber num={route.cars[0].oneWay} />/km | 
                      <span className="fw-bold ms-2 me-2" style={boldStyle}>MUV:</span> ₹<OptimizedNumber num={route.cars[2].oneWay} />/km
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <div className="text-center mt-4">
            <Button variant="warning" onClick={() => navigate('/popular-routes')} style={boldStyle}>View All Routes</Button>
          </div>
        </Container>
      </section>

      {/* Popular Destinations / Tourist Places */}
      <section className="py-5" style={{ backgroundColor: '#f4f4f4' }}>
        <Container>
          <h2 className="text-center mb-2" style={{ 
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            ...headingStyle
          }}>
            Our Service <span className="text-warning" style={headingStyle}>Tourist Places</span>
          </h2>
          <p className="text-center text-secondary mb-5" style={letterStyle}>
            Drop taxi service across South India — tap a place to book
          </p>

          <Row className="g-4 align-items-start">
            {popularDestinations.map((destination) => (
              <Col lg={6} md={6} key={destination.id}>
                <Card
                  className="border-0 shadow destination-card"
                  style={{ borderRadius: '16px', overflow: 'hidden' }}
                >
                  <div
                    className="d-flex align-items-center justify-content-between px-3 px-md-4 py-3"
                    style={{
                      background: 'linear-gradient(135deg, #111111 0%, #2a2a2a 100%)',
                      borderBottom: '3px solid #FFD700'
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <div
                        className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{ width: '40px', height: '40px', flexShrink: 0 }}
                      >
                        <FaMapMarkerAlt size={16} />
                      </div>
                      <h4 className="mb-0 text-white fw-bold" style={{ ...headingStyle, fontSize: 'clamp(1rem, 2.5vw, 1.15rem)' }}>
                        {destination.name}
                      </h4>
                    </div>
                    <span
                      className="rounded-pill px-3 py-1"
                      style={{
                        backgroundColor: 'rgba(255,215,0,0.2)',
                        color: '#FFD700',
                        fontSize: '0.75rem',
                        fontWeight: 700,
                        whiteSpace: 'nowrap',
                        ...boldStyle
                      }}
                    >
                      {destination.places.length} places
                    </span>
                  </div>

                  <Card.Body className="p-3 p-md-4" style={{ backgroundColor: '#ffffff' }}>
                    <div
                      className="tourist-places-grid"
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                        gap: '6px 12px',
                        backgroundColor: '#fafafa',
                        border: '1px solid #eee',
                        borderRadius: '12px',
                        padding: '12px'
                      }}
                    >
                      {destination.places.map((place, idx) => (
                        <button
                          key={idx}
                          type="button"
                          className="border-0 text-start w-100"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            backgroundColor: 'transparent',
                            borderRadius: '8px',
                            padding: '6px 8px',
                            fontSize: '0.82rem',
                            color: '#222',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s ease, color 0.2s ease',
                            lineHeight: 1.3,
                            ...letterStyle
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#FFD700';
                            e.currentTarget.style.color = '#111';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.color = '#222';
                          }}
                          onClick={() => {
                            dropCoordsRef.current = null;
                            setFormData(prev => ({
                              ...prev,
                              dropLocation: place
                            }));
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          <span
                            style={{
                              width: '6px',
                              height: '6px',
                              borderRadius: '50%',
                              backgroundColor: '#FFD700',
                              flexShrink: 0
                            }}
                          />
                          <span style={{ wordBreak: 'break-word' }}>{place}</span>
                        </button>
                      ))}
                    </div>

                    <div className="d-flex gap-2 mt-3">
                      <Button
                        variant="warning"
                        size="sm"
                        className="flex-grow-1 fw-bold"
                        style={{ borderRadius: '10px', ...boldStyle }}
                        onClick={() => {
                          dropCoordsRef.current = null;
                          setFormData(prev => ({
                            ...prev,
                            dropLocation: destination.places[0] || ''
                          }));
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                      >
                        BOOK DROP TAXI
                      </Button>
                      <Button
                        variant="outline-dark"
                        size="sm"
                        style={{ borderRadius: '10px', minWidth: '42px', ...boldStyle }}
                        onClick={() => window.location.href = `tel:+${CLIENT_PHONE_NUMBER}`}
                      >
                        <FaPhone />
                      </Button>
                      <Button
                        size="sm"
                        style={{
                          borderRadius: '10px',
                          minWidth: '42px',
                          backgroundColor: '#25d366',
                          borderColor: '#25d366',
                          color: '#fff',
                          ...boldStyle
                        }}
                        onClick={() =>
                          window.open(
                            `https://wa.me/${CLIENT_WHATSAPP_NUMBER}?text=${encodeURIComponent(
                              `Hi! I need a drop taxi to ${destination.name}`
                            )}`,
                            '_blank'
                          )
                        }
                      >
                        <FaWhatsapp />
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
        <style>{`
          @media (max-width: 575.98px) {
            .tourist-places-grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}</style>
      </section>

      {/* ABOUT SECTION */}
      <section className="py-5 bg-light">
        <Container>
          <h2 className="text-center mb-5" style={{ 
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            ...headingStyle
          }}>
            About <span className="text-warning" style={headingStyle}>Us</span>
          </h2>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <img 
                src="/images/sedan/swift-dzire-2.jpg"
                alt="Our Fleet"
                className="img-fluid rounded-3 shadow"
                loading="lazy"
              />
            </Col>
            <Col lg={6}>
              <h3 className="text-warning mb-4" style={headingStyle}>OUR COMPANY</h3>
              <p className="lead mb-3" style={letterStyle}>
                At <strong style={boldStyle}>Lexus DROP TAXI</strong>, we believe every journey should be safe, comfortable, and on time.
              </p>
              <p className="mb-3" style={letterStyle}>
                Since 2023, we've been proudly serving Tamilnadu, Kerala, Andhra Pradesh, Karnataka, and Pondicherry with reliable outstation and local taxi services for families, tourists, and business travelers.
              </p>
              <p className="mb-3" style={letterStyle}>
                From quick city drops to long-distance one-way and round trips, our professional drivers, well-maintained fleet, and transparent fares help you travel without stress or hidden charges.
              </p>
              <p className="mb-4" style={letterStyle}>
                Whether you need an airport transfer, a temple visit, or an interstate ride, we are available 24/7 with doorstep pickup, on-time arrivals, and friendly support every step of the way.
              </p>
              <Row className="g-3">
                {aboutStats.slice(0, 2).map((stat, idx) => (
                  <Col xs={6} key={idx}>
                    <Card className="border-0 shadow-sm p-3 text-center">
                      <div className="text-warning h3 mb-2">{stat.icon}</div>
                      <h5 className="fw-bold mb-1" style={boldStyle}>{stat.value}</h5>
                      <small className="text-secondary" style={letterStyle}>{stat.label}</small>
                    </Card>
                  </Col>
                ))}
              </Row>
              <div className="mt-4">
                <Button variant="warning" onClick={() => navigate('/about')} style={boldStyle}>Read More</Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* WHY CHOOSE US */}
      <section className="py-5 bg-light">
        <Container>
          <h2 className="text-center mb-5" style={{ 
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            ...headingStyle
          }}>
            Why <span className="text-warning" style={headingStyle}>Choose Us</span>
          </h2>
          <Row>
            {[
              { icon: '👨‍✈️', title: 'Trained Drivers', desc: 'Experienced and courteous drivers' },
              { icon: '⏰', title: 'Always On Time', desc: 'Punctual and reliable service' },
              { icon: '💰', title: 'Fair Pricing', desc: 'No hidden charges, ever' },
              { icon: '📍', title: 'GPS Vehicles', desc: 'Real-time tracking for safety' },
              { icon: '📞', title: '24/7 Support', desc: 'Round-the-clock assistance' },
              { icon: '🏔️', title: 'Hill Station Trips', desc: 'Special packages available' }
            ].map((item, index) => (
              <Col md={4} sm={6} key={index} className="mb-4">
                <Card className="border-0 shadow-sm p-4 text-center h-100">
                  <div className="display-3 mb-3">{item.icon}</div>
                  <h5 className="fw-bold mb-2" style={boldStyle}>{item.title}</h5>
                  <p className="text-secondary small mb-0" style={letterStyle}>{item.desc}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* CONTACT SECTION */}
      <section className="py-5">
        <Container>
          <h2 className="text-center mb-5" style={{ 
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            ...headingStyle
          }}>
            Contact <span className="text-warning" style={headingStyle}>Us</span>
          </h2>
          <Row>
            <Col lg={4} md={6} className="mb-4">
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="text-center p-4">
                  <div className="bg-warning rounded-circle d-inline-flex p-3 mb-3">
                    <FaMapMarkerAlt size={24} className="text-dark" />
                  </div>
                  <h5 className="fw-bold mb-3" style={boldStyle}>Visit Us</h5>
                  <p className="text-secondary mb-1" style={letterStyle}> 1-3-221, Kollam Main Road, Puliyarai,</p>
                  <p className="text-secondary mb-1" style={letterStyle}> Sengottai, Tenkasi - 627813.</p>

                  
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="text-center p-4">
                  <div className="bg-warning rounded-circle d-inline-flex p-3 mb-3">
                    <FaPhone size={24} className="text-dark" />
                  </div>
                  <h5 className="fw-bold mb-3" style={boldStyle}>Call Us</h5>
                  <p className="text-secondary mb-1" style={boldStyle}>+91 81481 11516</p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="text-center p-4">
                  <div className="bg-warning rounded-circle d-inline-flex p-3 mb-3">
                    <FaEnvelope size={24} className="text-dark" />
                  </div>
                  <h5 className="fw-bold mb-3" style={boldStyle}>Email Us</h5>
                  <p className="text-secondary mb-1" style={letterStyle}>lexusno1taxi@gmail.com</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <div className="text-center mt-4">
            <Button variant="warning" onClick={() => navigate('/contact')} style={boldStyle}>Contact Us</Button>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Home;